'use client';

// Страница «Уведомления» (вид утверждён владельцем 12.08.2026, план docs/NOTIFY-CENTER-PLAN.md
// этап 3). Прежние два пузыря «Куда писать» / «О чём писать» СНЯТЫ: двух мест настройки
// быть не должно.
//
// Страница = ОДИН пузырь «Что присылать» (FNotifyList, набор форм) со строками типов
// БЕЗ органов управления (владелец 12.08, вторая правка вида: «никаких тумблеров
// на строках — нажимаешь, открывается шторка, и настройки там»):
//   1) «Новости и предложения»    — сводка каналов доставки серым;
//   2) «Сообщения пользователей»  — сводка отбора переписок серым;
//   3) «Важные» (владелец 2026-08-21, Н5.2-в1/в2; прежнее рабочее слово волны —
//      «экстренные») — поломки подключений, увод аккаунта, коды входа. ВЫКЛЮЧИТЬ ИХ
//      НЕЛЬЗЯ: выбирается только «куда присылать», и последний способ доставки снять не
//      дают — модалка с объяснением (тот же отказ ждёт на сервере: need_one_channel).
//   4) «Финансовые» (владелец 09.10.2026) — оплата, продление, списания с карты, чеки.
//      ТОЛЬКО В ВЕБЕ и только почта и Телеграм (пуша у платёжных нет и не будет); в
//      приложении строки нет вовсе. Минимум один способ — как у «Важных».
//   В ВЕБЕ варианта «пуш» нет ни у одной группы (владелец 09.10.2026): только Телеграм и
//   почта; в приложении — как было.
// Строки «Сводки по сценариям» НЕТ (владелец 2026-08-21, Н5.2-в2): пер-ботовых «бот
// включён/выключен» не существует, про массовое гашение человек узнаёт важным
// уведомлением уровня аккаунта — настраивать было нечего, тумблеры включали пустоту.
// Тап по строке первого уровня открывает БОКОВУЮ шторку (штатный слой кабинета:
// useSlidePanel БЕЗ sheet — в приложении боковой слой стопкой, в вебе выезд справа;
// канон NATIVE-SLIDE §11). Владелец 12.08 (правка вида): все четыре строки страницы
// («Полученные» и три типа) открываются горизонтально; нижними листами остаются только
// ВТОРЫЕ уровни — низкая шторка режима аккаунта и предупреждение про запрет пуша.
// Вкл/выкл типа живёт ТОЖЕ в модалке (третья правка владельца 12.08: отдельного
// тумблера «присылать» НЕТ — дубль): у новостей «выключено» = сняты все каналы,
// у сообщений = сняты все аккаунты.
// Содержимое модалок РАЗНОЕ и не смешивается (владелец 12.08):
//   • новости и «Важные» → только «Куда присылать» (пуш / Телеграм / почта, галочки);
//     у «Важных» сверху вступление «приходят всегда» и замок последней галочки;
//   • сообщения → каналы доставки не выбираются вовсе (канал один — пуш): режим
//     ставится КАЖДОМУ АККАУНТУ отдельно, как «Уведомления → приложение» в системных
//     настройках iPhone (владелец 12.08 вечер, финальный вид, этап 3.v2 плана).
//     Шторка «Сообщения пользователей» — пузырь «Куда присылать» со строками-переходами
//     (FNotifyList): первой «Все аккаунты», второй «По умолчанию для новых аккаунтов»
//     (владелец 2026-08-21, Н2 — три уровня режима), ниже ЖИВЫЕ аккаунты клиента и
//     осиротевшие записи карты пометкой «отключён»; серым у каждой — ЕЁ режим словом.
//     Тап по строке открывает ВТОРУЮ, НИЗКУЮ шторку (стопкой поверх, канон
//     NATIVE-SLIDE §11) с выбором из трёх: «Все переписки» / «Только с выключенной
//     автоматизацией» / «Никакие». Выбрал — применилось и вернулись. У строки «Все
//     аккаунты» выбор проходит через штатное подтверждение (ConfirmInline: в приложении
//     родное окно iOS, на сайте — окошко по центру шторки).
//     Настройки «считать в наклейке» НЕТ (владелец: «не просил») — сообщения считаются
//     всегда, пока режим аккаунта не «Никакие».
//
// НИЖЕ ПУЗЫРЯ «Что присылать» — ОТДЕЛЬНЫЙ ПУЗЫРЬ-СТРОКА «ТИХИЕ ЧАСЫ» (владелец
// 2026-08-21, Н5.2-в1): это не «что присылать», а КОГДА молчать, поэтому строка своя, и
// уточняет она все типы разом. В её шторке — тумблер, границы времени (общий TimePick: в
// приложении родное колесо iOS, в вебе два списка набора; системный `input type="time"`
// не ставить) и часовой пояс общим TimezoneField — ВТОРАЯ ДВЕРЬ той же настройки, что в
// «Аккаунт → Язык и регион»: один компонент, одна ручка, один ключ кэша, второй разметки
// пояса в кабинете нет. Пояса у сервера ещё нет (tz null) — поле пустое, подпись честная
// («определится при следующем входе»), и на строке серым стоит то же самое: тишины без
// пояса не будет, и молчать об этом страница не имеет права.
// Сводка на строке — ПОЛНОЕ состояние до открытия («Пуш включён · Телеграм выключен ·
// Почта включена»), не короткий статус.
// Строка «Оплата и тариф» снята целиком (её тумблер не читал ни один отправитель).
//
// Разметки формы своей на странице НЕТ (канон UI-TEMPLATE-CANON «Элементы формы»):
// пузыри — form-kit (FPane/FBlock/FChoiceManyBlock/FNotifyList), контролы — набор
// (@scriptera/ui/kit: KSwitch, KButton).
//
// Push в iOS требует системного разрешения: включение пуша сперва спрашивает его у
// системы (nativeBridge), отказ — объяснением со ссылкой в системные настройки.
//
// ЦЕНТР ПОЛУЧЕННОГО (этап 4 плана, вид утверждён владельцем 12.08): НАД пузырём «Что
// присылать» стоит отдельный пузырь-строка «Полученные» с розовой пилюлей-цифрой
// непрочитанного; тап открывает шторку во всю высоту с лентой по дням. Данные —
// /api/user/notify-inbox (лента живая, в общий кэш кабинета не кладётся: пилюля обязана
// таять на глазах). В ПРИЛОЖЕНИИ платёжные записи ленты не показываются вовсе и не
// считаются в пилюле (CLAUDE.md запрет №7: ни цен, ни оплат в сборке для сторов).
//
// ШАПКИ ШТОРОК ПЕРВОГО УРОВНЯ — БЕЗ ГАЛОК (владелец 12.08, этап 6 плана): ни у
// «Полученных», ни у трёх типов кнопки действия в шапке нет, работает только «назад»
// (выбор в этих шторках применяется сразу, подтверждать нечего). «Прочитать всё»
// переехало из шапки В ЛЕНТУ — серой кнопкой в подписи первого дня.
import { useCallback, useEffect, useMemo, useRef, useState, useSyncExternalStore, type ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { DActions, DEmpty, DGroup, DHint } from './drawer-kit';
import { PaneRoundButton } from './page-action';
import { useSlidePanel } from './native-layer-host';
import {
  nativeBridge,
  nativeMethod,
  readRoleHex,
  useNativeApp,
  type NativeAccountField,
  type NativeAccountGroup,
  type NativeAccountPage,
  type NativeInboxData,
  type PushStatus,
} from '@/lib/native-app';
import { accountRoleHex } from '@/lib/account-native';
import { log as journalLog } from '@/lib/client-journal';
import { nativeInboxSupported, useNativeInbox } from '@/lib/inbox-native';
import { peekPersistent, refreshPersistent, subscribePersistent, usePersistentData } from '@/lib/use-persistent-data';
import {
  msgModeEdit,
  msgModeShown,
  msgSettingsAccounts,
  MSG_MODE_NEW,
  type MsgAccountRow,
  type MsgMode,
} from '@/lib/msg-modes-ui';
import { isPayNotice } from '@/lib/pay-notices';
import { QUIET_FROM, QUIET_TO, quietSummaryKind, readQuiet, urgentWouldEmpty, type QuietPrefs } from '@/lib/quiet-ui';
import { syncPushToken } from './push-prompt';
import { askNativeConfirm, hasNativeConfirm, hasNativeNotice, showNativeNotice } from './confirm-sheet';
import { pickNativeTime } from './date-range';
import { zoneLabel } from '@/lib/timezones';
import { imgSquarePng } from './avatar';
import { Sk } from './skeleton';
import { ChannelIcon, InstaGlyph, TgGlyph, channelHex, nativeChannelTile } from './bot-templates';
import { ConfirmInline } from './confirm-inline';
import { TimePick } from './date-range';
import { KListGroup, KListNote, KListRow, KWheelDialog } from '@scriptera/ui/kit';
import { usePhoneLook } from './layout-mode';
import { TimezoneField, useTimezoneSetting, useUserTz } from './timezone-field';
import {
  FBlock,
  FChoiceBlock,
  FChoiceManyBlock,
  FHint,
  FIn,
  FNotifyList,
  FPane,
  KBareButton,
  KButton,
  KSwitch,
} from './form-kit';

/** Телефон в браузере — листы уведомлений стопкой с «×» (ТЗ WEB-PARITY-3 К7/К9/К11). */
const phoneWebNow = (): boolean =>
  typeof window !== 'undefined' &&
  !document.documentElement.classList.contains('app') &&
  window.matchMedia('(max-width: 820px)').matches;

// Данные страницы живут в общем кэше кабинета (ключ cabinet:notifications): открытие
// шторки повторно НЕ грузит заново с нуля — кэш виден сразу, свежее доливается фоном
// (CLAUDE.md п.5 + HOW-IT-WORKS «Данные на фронте»).
export const NOTIF_KEY = 'cabinet:notifications';
export const NOTIF_URL = '/api/user/notifications';

/** Каналы доставки одного типа уведомлений. */
interface ChSet {
  push: boolean;
  tg: boolean;
  email: boolean;
}

/** Каналы «Финансовых»: пуша у платёжных нет и не будет (запрет №7). */
interface FinSet {
  tg: boolean;
  email: boolean;
}

/** Настройки типа «Сообщения пользователей»: канал один (пуш), настраивается РЕЖИМ
 *  КАЖДОГО аккаунта. Карта режимов: '*' — значение по умолчанию (им живут аккаунты,
 *  которых в карте нет), остальные ключи — аккаунты ('tg:<id>' / 'ig:<id>'). */
interface MsgPrefs {
  modes: Record<string, MsgMode>;
}

/** Канал общения клиента (его подключённый бот/аккаунт). Форма общая со стороной
 *  разбора карты (lib/msg-modes-ui): `off` — подключения больше нет, строка живёт
 *  только ради своей записи в карте режимов. */
type Acc = MsgAccountRow;

interface Types {
  marketing: ChSet;
  messages: MsgPrefs;
  /** «Важные»: те же три канала, но снять последний нельзя. null — ответ старый (кэш с
   *  прошлой выкатки): строку не рисуем вовсе, остальную страницу из-за неё не гасим. */
  urgent: ChSet | null;
  /** «Финансовые» (только веб). null — ответ старый: строку не рисуем. */
  finance: FinSet | null;
}

interface Prefs {
  ok?: boolean;
  email?: string;
  tgLinked?: boolean;
  tgName?: string | null;
  tgBlocked?: boolean;
  channels?: { tg: boolean; email: boolean; push: boolean };
  types?: unknown;
  accounts?: unknown;
  /** Тихие часы клиента (границы по его поясу). */
  quiet?: unknown;
}

type ChKind = 'marketing' | 'urgent';

/** Каналы типа из ответа сервера. Старый ответ (types.marketing = boolean) не проходит. */
function readCh(v: unknown): ChSet | null {
  if (!v || typeof v !== 'object') return null;
  const o = v as Record<string, unknown>;
  return { push: !!o.push, tg: !!o.tg, email: !!o.email };
}

/** Каналы «Финансовых» из ответа сервера (только почта и Телеграм). */
function readFin(v: unknown): FinSet | null {
  if (!v || typeof v !== 'object') return null;
  const o = v as Record<string, unknown>;
  return { tg: !!o.tg, email: !!o.email };
}

/** Карта режимов из ответа сервера КАК ЕСТЬ: чужие значения отбрасываем, своего в неё
 *  НЕ дописываем (владелец 2026-08-21, У2). Прежняя достройка '*': 'all' делала вид,
 *  будто значение по умолчанию выбрано человеком, и уезжала обратно на сервер. Аккаунт
 *  без записи живёт наследованием, а чем его подписать — решает msgModeShown. */
function readModes(v: unknown): Record<string, MsgMode> | null {
  if (!v || typeof v !== 'object') return null;
  const out: Record<string, MsgMode> = {};
  for (const [k, val] of Object.entries(v as Record<string, unknown>)) {
    if (val === 'all' || val === 'manual' || val === 'off') out[k] = val;
  }
  return out;
}

// Тихая деградация (серверная часть плана едет отдельно): нет нового поля types —
// страница показывает скелетон, а не падает и не рисует полупустую форму.
function readTypes(raw: unknown): Types | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const marketing = readCh(o.marketing);
  const m = o.messages;
  if (!marketing || !m || typeof m !== 'object') return null;
  const modes = readModes((m as Record<string, unknown>).modes);
  if (!modes) return null;
  return { marketing, messages: { modes }, urgent: readCh(o.urgent), finance: readFin(o.finance) };
}

/**
 * Режимы ЖИВЫХ аккаунтов клиента (аккаунтов нет — говорит значение по умолчанию).
 *
 * Отключённые строки в счёт не идут: они стоят в списке только ради своей записи, и
 * сводка «настроены по-разному» из-за давно стёртого аккаунта — неправда.
 */
function modeList(modes: Record<string, MsgMode>, accounts: Acc[]): MsgMode[] {
  const live = accounts.filter((a) => !a.off);
  return live.length ? live.map((a) => msgModeShown(modes, a.key)) : [msgModeShown(modes, '*')];
}

/** Один режим на всех — он; разнобой — null. */
function oneMode(list: MsgMode[]): MsgMode | null {
  const first = list[0] ?? 'all';
  return list.every((m) => m === first) ? first : null;
}

/** Ключ словаря для названия режима (им подписаны и строки, и варианты выбора). */
function modeKey(m: MsgMode): 'notifMsgScopeAll' | 'notifMsgScopeManual' | 'notifMsgScopeNone' {
  if (m === 'off') return 'notifMsgScopeNone';
  return m === 'manual' ? 'notifMsgScopeManual' : 'notifMsgScopeAll';
}

function readAccounts(raw: unknown): Acc[] {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((x) => {
    if (!x || typeof x !== 'object') return [];
    const o = x as Record<string, unknown>;
    if (typeof o.key !== 'string' || typeof o.name !== 'string') return [];
    return [
      {
        key: o.key,
        name: o.name,
        channel: o.channel === 'ig' ? 'ig' : 'tg',
        // Адрес нашей ручки с фотографией аккаунта (ручка настроек отдаёт его общей
        // рукой credAvatars) — лицо аккаунта главнее знака сети.
        ...(typeof o.avatar === 'string' && o.avatar ? { avatar: o.avatar } : {}),
        ...(o.off ? { off: true } : {}),
      },
    ];
  });
}

// ── ЦЕНТР ПОЛУЧЕННОГО: данные ленты ────────────────────────────────────────────────
export const INBOX_URL = '/api/user/notify-inbox';
/** Сколько записей просим за раз (пришло меньше — лента кончилась). */
const INBOX_PAGE = 30;

/** Запись ленты: тексты приходят готовыми — центр их не рендерит заново. */
interface Notice {
  id: string;
  key: string;
  title: string;
  body: string;
  /** Путь БЕЗ языка ('/app/bots/<id>'); язык подставляет router кабинета. */
  path: string;
  createdAt: string;
  readAt: string | null;
}

/** Загруженный кусок ленты + свежая цифра непрочитанного с сервера. */
interface Inbox {
  items: Notice[];
  /** Непрочитанных СТОЛЬКО, СКОЛЬКО ЧЕЛОВЕК УВИДИТ: считает сервер по всей ленте, а не
   *  по загруженной странице, и в приложении уже без денежных записей (Ф8/Д18). */
  unread: number;
  /** Курсор следующей страницы (время самой старой отданной записи). */
  nextBefore: string | null;
  /** Сервер отдал полную страницу — значит есть что догружать. */
  more: boolean;
  /** Просрочка оплаты (FUNNEL-TZ §4.4): сервер ставит true только в вебе — наклейка «!» на
   *  «Аккаунте» и «Подписке». Нет поля (старый ответ) — false. */
  overdue: boolean;
}

// ПЛАТЁЖНОЕ В ПРИЛОЖЕНИИ НЕ ПОКАЗЫВАЕМ (CLAUDE.md запрет №7, ЖЕЛЕЗНОЕ): воронка,
// напоминания об оплате и списания говорят про деньги — в сборке для сторов их нет ни
// в ленте, ни в пилюле. В вебе видно всё. Список видов — общий с сервером
// (lib/pay-notices.ts): по нему же ручка считает непрочитанное для пилюли.

function readNotices(raw: unknown): Notice[] {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((x) => {
    if (!x || typeof x !== 'object') return [];
    const o = x as Record<string, unknown>;
    if (typeof o.id !== 'string' || typeof o.createdAt !== 'string') return [];
    return [
      {
        id: o.id,
        key: typeof o.key === 'string' ? o.key : '',
        title: typeof o.title === 'string' ? o.title : '',
        body: typeof o.body === 'string' ? o.body : '',
        path: typeof o.path === 'string' ? o.path : '',
        createdAt: o.createdAt,
        readAt: typeof o.readAt === 'string' ? o.readAt : null,
      },
    ];
  });
}

/** Ответ ручки ленты → кусок ленты (null — негодный ответ). */
function inboxOf(raw: unknown): Inbox | null {
  const j = raw as Record<string, unknown> | null;
  if (!j || !j.ok) return null;
  const items = readNotices(j.items);
  return {
    items,
    unread: typeof j.unread === 'number' ? j.unread : 0,
    nextBefore: typeof j.nextBefore === 'string' ? j.nextBefore : null,
    more: items.length >= INBOX_PAGE,
    overdue: j.overdue === true,
  };
}

/** Кусок ленты с сервера (догрузка старых страниц). Ошибка сети — null. */
async function loadInbox(before: string | null): Promise<Inbox | null> {
  const q = `?limit=${INBOX_PAGE}${before ? `&before=${encodeURIComponent(before)}` : ''}`;
  const j = (await fetch(`${INBOX_URL}${q}`)
    .then((r) => r.json())
    .catch(() => null)) as unknown;
  return inboxOf(j);
}

// ПЕРВАЯ СТРАНИЦА ЛЕНТЫ — ЧЕРЕЗ КЭШ usePersistentData (PREFETCH-TZ §2.5, канон CLAUDE.md «Данные фронта —
// только через usePersistentData»): прежде лента жила только в памяти и после перезагрузки страницы
// начиналась со скелетона. Теперь первая страница лежит в общем кэше (localStorage) — открытие сразу с
// ней, свежая ложится поверх тихо. Состояние ленты по-прежнему ОДНО (inboxStore, инвариант ниже): кэш
// лишь кормит его первой страницей; догрузка старых страниц — как была, мимо кэша.
const INBOX_FIRST_KEY = 'cabinet:inbox:first';
const INBOX_FIRST_URL = `${INBOX_URL}?limit=${INBOX_PAGE}`;
let inboxBridged = false;
/** Последний применённый ответ кэша: смена только флагов снимка (ошибка, загрузка) ленту не трогает —
 *  иначе неудачный опрос возвращал бы поверх оптимистичной отметки «прочитано» старую страницу. */
let inboxApplied: unknown = null;

function bridgeInbox(): void {
  if (inboxBridged || typeof window === 'undefined') return;
  inboxBridged = true;
  const apply = () => {
    const raw = peekPersistent<unknown>(INBOX_FIRST_KEY);
    if (!raw || raw === inboxApplied) return;
    inboxApplied = raw;
    const fresh = inboxOf(raw);
    if (fresh) mergeFirstPage(fresh);
  };
  apply();
  subscribePersistent(INBOX_FIRST_KEY, apply);
}

// ── ОБЩИЙ ЖИВОЙ ИСТОЧНИК ЛЕНТЫ ─────────────────────────────────────────────────────
// INVARIANT(scriptera): лента полученного — ОДНО состояние на страницу и все её слои.
// Причина: шторка живёт отдельным слоем и своей веткой дерева (перерисовку/перемонтаж
// страницы под собой она не обязана переживать), а владелец 12.08 потребовал: «пилюля
// гаснет сразу, и под шторкой тоже» — отметка «прочитано» обязана двигать пилюлю и точки
// В МОМЕНТ действия, а не при закрытии шторки. Поэтому лента лежит МОДУЛЕМ и раздаётся
// через useSyncExternalStore: у страницы и у шторки один и тот же снимок, копий нет.
// Канон: docs/NOTIFY-CENTER-PLAN.md. Событие окна для этого не заводить — подписка своя.
let inboxStore: Inbox | null = null;
const inboxSubs = new Set<() => void>();

function setInbox(next: Inbox | null): void {
  inboxStore = next;
  for (const fn of inboxSubs) fn();
}

function subscribeInbox(fn: () => void): () => void {
  inboxSubs.add(fn);
  return () => {
    inboxSubs.delete(fn);
  };
}

/** Подписка на ленту + мост к кэшу первой страницы (после перезагрузки лента сразу из кэша). Мост
 *  ставится при подписке (фаза фиксации), а не в рендере: смена ленты в рендере чужого компонента
 *  запрещена React. */
function subscribeInboxBridged(fn: () => void): () => void {
  const off = subscribeInbox(fn);
  bridgeInbox();
  return off;
}

/** Живой снимок ленты. На сервере ленты нет вовсе — там всегда null (скелетон). */
function useInbox(): Inbox | null {
  return useSyncExternalStore(
    subscribeInboxBridged,
    () => inboxStore,
    () => null,
  );
}

// ── ОБЩАЯ ЗАГРУЗКА ЛЕНТЫ ────────────────────────────────────────────────────────────
// Ленту просит и страница «Уведомления», и КОЛОКОЛЬЧИК шапки «Аккаунта» (Н5.2-в1):
// запрос один на всех — двух гонящихся загрузок и двух счётчиков быть не должно.
let inboxLoading: Promise<void> | null = null;

/**
 * Обновить ленту первой страницей. Уже догруженные страницы НЕ теряются: свежие записи
 * встают сверху, прежние остаются под ними — иначе возврат на страницу схлопывал бы
 * пролистанную ленту к первой странице.
 */
export function refreshInbox(): Promise<void> {
  if (inboxLoading) return inboxLoading;
  bridgeInbox();
  // Запрос — тем же ключом кэша; ответ ляжет в ленту через мост (bridgeInbox). Один запрос на всех:
  // повторный вызов в пути склеивает сам хук (дедуп по ключу).
  refreshPersistent(INBOX_FIRST_KEY, INBOX_FIRST_URL, { accept: (j) => !!(j as { ok?: boolean })?.ok });
  inboxLoading = Promise.resolve().finally(() => {
    inboxLoading = null;
  });
  return inboxLoading;
}

/** Свежая первая страница: сверху новые записи, ниже — уже догруженные старые (не теряются);
 *  просрочка оплаты (FUNNEL-TZ §4.4) — всегда из свежего снимка. */
function mergeFirstPage(fresh: Inbox): void {
  const prev = inboxStore;
  if (!prev || prev.items.length <= fresh.items.length) {
    setInbox(fresh);
    return;
  }
  const seen = new Set(fresh.items.map((n) => n.id));
  setInbox({
    items: [...fresh.items, ...prev.items.filter((n) => !seen.has(n.id))],
    unread: fresh.unread,
    nextBefore: prev.nextBefore,
    more: prev.more,
    overdue: fresh.overdue,
  });
}

/**
 * ЦИФРА НАКЛЕЙКИ непрочитанного — для колокольчика шапки «Аккаунта».
 *
 * INVARIANT(scriptera): цифру даёт СЕРВЕРНЫЙ счёт непрочитанного (поле `unread` ручки
 * /api/user/notify-inbox), а не длина загруженной страницы ленты. Причина: лента едет
 * страницами по 30 — считать непрочитанное по ней значит врать всем, у кого его больше
 * (претензия Д18). Канон: docs/CABINET-UX-FIXLIST.md, раздел «Н5.2-в1».
 * В приложении из счёта вычитается платёжное, которого там не видно (запрет №7), — и
 * вычитает его САМ СЕРВЕР по UA (Ф8): своего признака «мы в приложении» хук не держит.
 *
 * `enabled` — считать ли вообще (шапка зовёт хук всегда, а лента нужна только на
 * «Аккаунте»). Наклейка обновляется при ВОЗВРАТЕ на страницу: вкладка снова видима,
 * окно получило фокус, страница приехала из кэша истории (bfcache).
 */
export function useInboxBadge(enabled = true): number {
  const inbox = useInbox();
  useEffect(() => {
    if (!enabled) return;
    void refreshInbox();
    const back = () => {
      if (document.visibilityState === 'visible') void refreshInbox();
    };
    window.addEventListener('focus', back);
    window.addEventListener('pageshow', back);
    document.addEventListener('visibilitychange', back);
    return () => {
      window.removeEventListener('focus', back);
      window.removeEventListener('pageshow', back);
      document.removeEventListener('visibilitychange', back);
    };
  }, [enabled]);
  // Шов слияния Ф8 и О-Б: сервер (ручка notify-inbox) УЖЕ отдаёт unread без платёжного
  // в приложении (по UA) — клиентской вычитки не нужно, второго счётчика не заводим.
  return inbox?.unread ?? 0;
}

/** Просрочка оплаты из того же снимка ленты (FUNNEL-TZ §4.4) — для наклейки «!». */
export function useInboxOverdue(): boolean {
  return useInbox()?.overdue ?? false;
}

/** Не чаще раза в минуту оболочка переспрашивает ручку при возврате на вкладку (§4.4). */
const SHELL_INBOX_GAP_MS = 60_000;
let shellInboxAt = 0;

/**
 * ОБОЛОЧКА СПРАШИВАЕТ ЛЕНТУ САМА (FUNNEL-TZ §4.4): наклейке просрочки на вкладке «Аккаунт» и в
 * рейле мало опроса useInboxBadge — тот живёт только на панели «Аккаунт». Один запрос при
 * монтировании и повтор, когда вкладка снова видна, но не чаще раза в минуту. Запрос тот же
 * (refreshInbox): второго счётчика и второй загрузки нет.
 */
export function useShellInboxPoll(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const ask = () => {
      const now = Date.now();
      if (now - shellInboxAt < SHELL_INBOX_GAP_MS) return;
      shellInboxAt = now;
      void refreshInbox();
    };
    shellInboxAt = 0;
    ask();
    const back = () => {
      if (document.visibilityState === 'visible') ask();
    };
    document.addEventListener('visibilitychange', back);
    return () => document.removeEventListener('visibilitychange', back);
  }, [enabled]);
}

/**
 * Открыть ЦЕНТР ПОЛУЧЕННОГО — одна рука на весь кабинет.
 *
 * INVARIANT(scriptera): центр уведомлений открывается ТОЛЬКО этой рукой — и строкой
 * «Полученные» страницы «Уведомления», и колокольчиком шапки «Аккаунта». Причина:
 * второй способ открытия разъедется с первым (заголовок, направление слоя, лента).
 * Канон: docs/NOTIFY-CENTER-PLAN.md + docs/CABINET-UX-FIXLIST.md «Н5.2-в1».
 * Галок в шапке шторки НЕТ (владелец 12.08): работает только «назад», «Прочитать всё»
 * живёт в самой ленте.
 */
export function useOpenInbox(): (focusId?: string) => void {
  const t = useTranslations('cabinet.settings');
  const panel = useSlidePanel();
  // focusId — id записи центра: лента откроется и сразу покажет эту запись поверх
  // (тап по пушу ведёт в саму новость).
  return (focusId?: string) => {
    // В ПРИЛОЖЕНИИ ЛЕНТУ РИСУЕТ НАТИВ (волна 2): те же ряды, тот же боковой выезд, но
    // родным экраном — веб-слоя при нём не бывает (инвариант у InboxNativeScreen).
    // Старая сборка метода не имеет (feature-detect) — открывается прежняя шторка.
    if (nativeInboxSupported()) {
      openNativeInbox(focusId);
      return;
    }
    panel.open({
      title: t('notifInbox'),
      // БОКОВОЙ выезд справа (владелец 12.08, подтверждено 29.08.2026 — попытка открыть
      // «Полученные» нижним листом отменена): и из угла страницы, и из колокольчика шапки.
      // Телефон в браузере (ТЗ WEB-PARITY-3 К11, кадр iOS K05): стопка с «×» — направление
      // листа на телефоне у всех одно (NATIVE-SLIDE §11). «×» и тогда, когда центр открыт поверх
      // страницы «Уведомления» (колокольчик её шапки) — это новый лист, а не шаг вглубь (владелец 09.10.2026).
      ...(phoneWebNow() ? { sheet: true, lead: 'close' as const } : {}),
      body: <InboxModal focusId={focusId} />,
    });
  };
}

/**
 * Открытие центра по АДРЕСУ: ?inbox=1 — лента, ?inbox=<id записи> — сразу сама запись.
 * Это единственный адресуемый вход в центр (у шторки нет своего роута) — им живут тап
 * по пушу (push-open.tsx ведёт сюда без промежуточного окна) и ссылки в приложение.
 * Параметр срезается из адреса сразу: обновление страницы и «назад» центр не переоткрывают.
 * Рисуется в оболочке кабинета рядом с PushOpen (внутри слоёв — руке нужна шторка).
 */
export function InboxDeepLink() {
  const openInbox = useOpenInbox();
  const params = useSearchParams();
  const wanted = params.get('inbox');
  const handled = useRef(false);
  useEffect(() => {
    if (!wanted) {
      handled.current = false;
      return;
    }
    if (handled.current) return; // StrictMode зовёт эффект дважды — шторка одна
    handled.current = true;
    const sp = new URLSearchParams(window.location.search);
    sp.delete('inbox');
    const qs = sp.toString();
    history.replaceState(
      history.state,
      '',
      window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash,
    );
    openInbox(wanted === '1' ? undefined : wanted);
    // openInbox пересоздаётся каждый рендер — сработать эффект обязан по параметру.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wanted]);
  // Хозяин РОДНОЙ ленты приложения (волна 2): стоит здесь же — этот кусок живёт в
  // оболочке кабинета, а значит переживает переходы между разделами.
  return <InboxNativeHost />;
}

/** Снять ДОСТАВЛЕННЫЕ пуши из шторки iOS после прочтения: по id записей центра
 *  (userInfo.nid в payload пуша) или все разом. Старые сборки метода не знают —
 *  feature-detect, в вебе тишина; наклейку-цифру это не трогает (её ведёт syncBadge). */
function clearDeliveredPush(ids: string[] | 'all'): void {
  if (!nativeMethod('clearDeliveredPush')) return;
  void nativeBridge()
    ?.clearDeliveredPush?.(ids === 'all' ? {} : { ids })
    .catch(() => {});
}

/** Отметить прочитанным на сервере: перечисленные записи или всю ленту. */
async function saveRead(ids: string[] | 'all'): Promise<boolean> {
  const r = (await fetch(INBOX_URL, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ read: ids }),
  })
    .then((res) => res.json())
    .catch(() => ({ ok: false }))) as { ok?: boolean };
  return !!r?.ok;
}

// ── Значки строк ───────────────────────────────────────────────────────────────────
// Владелец 12.08: «без иконок скучно». Глифы — контурные, в общем стиле кабинета
// (stroke currentColor, 1.9), плитку 34/11 и размер 20 даёт сам набор (.ic у FNotifyList).
// Цвета — из живой палитры пунктов кабинета (settings.tsx: --violet / --amber / --green /
// --blue), у каждой строки СВОЙ; --teal не берём — он закреплён за MCP-сервером.
const glyph = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.9,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/** «Полученные» — колокольчик. */
const BellGlyph = () => (
  <svg {...glyph}>
    <path d="M18 15.5V11a6 6 0 1 0-12 0v4.5L4.5 18h15z" />
    <path d="M10 20.5a2 2 0 0 0 4 0" />
  </svg>
);

/**
 * КРУГЛАЯ КНОПКА «ПОЛУЧЕННЫЕ» в углу шапки страницы «Уведомления» (владелец 29.08.2026,
 * отменяет строку в теле). Та же серия, что угловые кнопки «Аккаунта»: белый круг с
 * тёмным значком. Наклейка непрочитанного — та же пара розовых, что у пилюли-цифры строк
 * набора. Центр открывает ОДНА рука на весь кабинет (useOpenInbox) — своей не заводим.
 * В приложении кнопку дублирует родная шапка (свод «Аккаунта» отдаёт SF-значок bell).
 */
export function InboxTopButton() {
  const t = useTranslations('cabinet.settings');
  const openInbox = useOpenInbox();
  const unread = useInboxBadge();
  return (
    // Общий кружок шапки поля (PaneRoundButton, TARIFF-PRO-2 §3.10); наклейка непрочитанного — по углу кружка.
    <PaneRoundButton
      className="acct-bell"
      label={t('notifInbox')}
      onClick={() => openInbox()}
      icon={
        <>
          <BellGlyph />
          {unread > 0 ? <span className="acct-bell-badge">{unread > 99 ? '99+' : unread}</span> : null}
        </>
      }
    />
  );
}

/** «Новости и предложения» — мегафон. */
const MegaphoneGlyph = () => (
  <svg {...glyph}>
    <path d="M3.5 10.8 20 6v12L3.5 13.2z" />
    <path d="M11.4 16.6a3 3 0 1 1-5.7-1.6" />
  </svg>
);

/** «Сообщения пользователей» — пузырь переписки со строками. */
const BubbleGlyph = () => (
  <svg {...glyph}>
    <path d="M21 12a8 8 0 0 1-11.6 7.2L4 21l1.9-5A8 8 0 1 1 21 12z" />
    <path d="M8 11h8M8 14h5" />
  </svg>
);

/** «Все аккаунты» — сетка квадратиков (все каналы разом, а не какой-то один). */
const GridGlyph = () => (
  <svg {...glyph}>
    <rect x="3.6" y="3.6" width="7.2" height="7.2" rx="2.2" />
    <rect x="13.2" y="3.6" width="7.2" height="7.2" rx="2.2" />
    <rect x="3.6" y="13.2" width="7.2" height="7.2" rx="2.2" />
    <rect x="13.2" y="13.2" width="7.2" height="7.2" rx="2.2" />
  </svg>
);

/** «По умолчанию для новых аккаунтов» — плюс в кружке (аккаунт, которого ещё нет). */
const NewAccGlyph = () => (
  <svg {...glyph}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M12 8.4v7.2M8.4 12h7.2" />
  </svg>
);

/** «Важные» — щит с восклицательным знаком (то, что доходит всегда). Цвет янтарный:
 *  по палитре янтарь — сигнал «внимание», а не ещё один декоративный оттенок. */
const ShieldGlyph = () => (
  <svg {...glyph}>
    <path d="M12 3.2 5.4 6v5.6c0 4 2.8 7.4 6.6 8.8 3.8-1.4 6.6-4.8 6.6-8.8V6z" />
    <path d="M12 8.6v4M12 15.6v.1" />
  </svg>
);

/** «Финансовые» — банковская карта. */
const CardGlyph = () => (
  <svg {...glyph}>
    <rect x="3" y="5.6" width="18" height="12.8" rx="2.4" />
    <path d="M3 10h18M6.6 14.6h3.6" />
  </svg>
);

/** «Тихие часы» — месяц (ночь). */
const MoonGlyph = () => (
  <svg {...glyph}>
    <path d="M20 14.4A8.4 8.4 0 0 1 9.6 4 8.4 8.4 0 1 0 20 14.4z" />
  </svg>
);

/** КАНАЛЫ ДОСТАВКИ ОДНИМ СЛОВАРЁМ (подпись + вторая строка) — рука общая для
 *  веб-модалки типа и для галочек РОДНОЙ страницы приложения.
 *
 *  Вторая строка — ФАКТ, а не объяснение (владелец 09.09.2026): под «Телеграм» стоит
 *  @имя привязанного аккаунта, под «Почта» — адрес; описательные подсказки «придёт в
 *  приложение», «отправится в подключённый Телеграм», «письмом на …» сняты — они
 *  повторяли название галочки. Помеха (запрет системы, остановленный бот,
 *  непривязанный бот) вытесняет факт: она важнее адреса. */
function useChannelRows(): (o: {
  email: string;
  tgLinked: boolean;
  tgBlocked: boolean;
  tgName: string | null;
  pushDenied: boolean;
  /** Веб: варианта «пуш» нет (владелец 09.10.2026) — только Телеграм и почта. */
  noPush?: boolean;
}) => { value: 'push' | 'tg' | 'email'; label: string; hint?: string }[] {
  const t = useTranslations('cabinet.settings');
  return (o) => [
    ...(o.noPush
      ? []
      : [{ value: 'push' as const, label: t('notifChPush'), ...(o.pushDenied ? { hint: t('notifPushDenied') } : {}) }]),
    {
      value: 'tg',
      label: t('notifChTg'),
      hint: o.tgBlocked
        ? t('notifTgBlocked')
        : !o.tgLinked
          ? t('notifTgNone')
          : (o.tgName ?? undefined),
    },
    { value: 'email', label: t('notifChEmail'), ...(o.email ? { hint: o.email } : {}) },
  ];
}

/** НАСТРОЙКИ УВЕДОМЛЕНИЙ: ДАННЫЕ И ЗАПИСЬ — ОДНА РУКА на веб-шторку и на родную
 *  страницу приложения (docs/NATIVE-ACCOUNT-PLAN.md, этап В). Второй правды о настройке
 *  в кабинете нет: тумблер родной страницы пишет ровно то же, что галочка веб-модалки. */
export interface NotifyPrefs {
  data: Prefs | null;
  types: Types | null;
  accounts: Acc[];
  quiet: QuietPrefs | null;
  /** Система запретила пуш (только в приложении). */
  pushDenied: boolean;
  ensurePush: () => Promise<boolean>;
  setChannels: (kind: ChKind, next: ChSet) => Promise<boolean>;
  setUrgent: (next: ChSet) => Promise<boolean>;
  /** «Финансовые» (только веб): почта и Телеграм, снять последний нельзя. */
  setFinance: (next: FinSet) => Promise<boolean>;
  applyQuiet: (patch: Partial<QuietPrefs>) => Promise<boolean>;
  setMsgMode: (key: string, mode: MsgMode) => Promise<boolean>;
  setMsgAll: (mode: MsgMode) => Promise<boolean>;
  forgetMsgAccount: (key: string) => Promise<boolean>;
  openNeedChannel: () => void;
  /** Тот же отказ «оставьте хотя бы один способ» — словами «Финансовых». */
  openNeedFinance: () => void;
  /** Сводки строк готовыми словами — одинаковые в вебе и в приложении. Без поля push
   *  (веб, «Финансовые») сводка считает только Телеграм и почту. */
  sumChannels: (c: { push?: boolean; tg: boolean; email: boolean }) => string;
  sumMessages: (m: MsgPrefs) => string;
  sumQuiet: (q: QuietPrefs) => string;
  /** Готовые ряды каналов доставки (подпись + пояснение). */
  channels: { value: 'push' | 'tg' | 'email'; label: string; hint?: string }[];
  /** Свежий снимок данных: тело модалки живёт отдельным слоем и держит замыкание
   *  момента открытия (см. applyTypes) — читаем через ref, а не из замыкания. */
  curTypes: () => Types | null;
  curAccounts: () => Acc[];
  curQuiet: () => QuietPrefs | null;
}

export function useNotifyPrefs(): NotifyPrefs {
  const t = useTranslations('cabinet.settings');
  const tc = useTranslations('cabinet');
  const panel = useSlidePanel();
  const { data, mutate } = usePersistentData<Prefs>(NOTIF_KEY, NOTIF_URL, {
    accept: (j) => !!(j as { ok?: boolean })?.ok,
  });
  const types = readTypes(data?.types);
  const accounts = readAccounts(data?.accounts);
  const quiet = readQuiet(data?.quiet);
  // Пояс берём ОТТУДА ЖЕ, откуда его показывает и правит поле (общий кэш «Языка и
  // региона»): иначе строка «Тихие часы» ещё писала бы «пояс не определился» после того,
  // как человек только что выбрал его в шторке.
  const tz = useUserTz();
  // Свежий снимок данных для записи из уже открытой модалки (см. applyTypes).
  const dataRef = useRef<Prefs | null>(null);
  useEffect(() => {
    dataRef.current = data ?? null;
  }, [data]);
  const [pushStatus, setPushStatus] = useState<PushStatus | null>(null);
  // Тот же ответ системы копией в ref: тело модалки живёт отдельным слоем и держит
  // замыкание момента открытия — свежий статус читаем через ref, а не из замыкания.
  const pushRef = useRef<PushStatus | null>(null);
  const setPush = useCallback((s: PushStatus | null) => {
    pushRef.current = s;
    setPushStatus(s);
  }, []);
  const native = !!nativeMethod('getPushState');

  useEffect(() => {
    const b = nativeBridge();
    b?.getPushState?.()
      .then((s) => setPush(s.status))
      .catch(() => {});
  }, [setPush]);

  // Ответ ручки отдаём ЦЕЛИКОМ, а не «получилось/нет»: у отказа бывает причина, которую
  // человеку положено объяснить (need_one_channel у «Важных» — модалкой).
  const save = useCallback(async (payload: Record<string, unknown>): Promise<{ ok: boolean; error?: string }> => {
    const r = await fetch(NOTIF_URL, {
      method: 'PATCH',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .catch(() => ({ ok: false }));
    const o = (r ?? {}) as { ok?: boolean; error?: unknown };
    return { ok: !!o.ok, ...(typeof o.error === 'string' ? { error: o.error } : {}) };
  }, []);

  // Разрешение системы на пуш (только в приложении): отказ объясняем и ведём в настройки.
  // В свежей сборке это РОДНОЙ низкий лист (волна 3): тот же заголовок, тот же текст и
  // та же кнопка в системные настройки — веб-слоя при нём не бывает.
  const openPushDenied = useCallback(() => {
    if (hasNativeNotice()) {
      void showNativeNotice({
        style: 'sheet',
        title: t('pushDeniedTitle'),
        text: t('pushDeniedBody'),
        ...(nativeMethod('openSystemSettings') ? { primary: t('pushOpenSettings') } : {}),
        secondary: tc('close'),
      }).then((ok) => {
        if (ok) void nativeBridge()?.openSystemSettings?.();
      });
      return;
    }
    panel.open({
      title: t('pushDeniedTitle'),
      sheet: true,
      sheetDetent: 0.4,
      body: (
        <DGroup>
          <DHint>{t('pushDeniedBody')}</DHint>
          {nativeMethod('openSystemSettings') && (
            <DActions>
              <KButton tone="primary" onClick={() => void nativeBridge()?.openSystemSettings?.()}>
                {t('pushOpenSettings')}
              </KButton>
            </DActions>
          )}
        </DGroup>
      ),
    });
  }, [panel, t, tc]);

  // «Важные»: последний способ доставки снять нельзя — объясняем ПОЧЕМУ (капкан №6).
  // Тот же слой, что у объяснения про запрет пуша: в приложении это родной нижний лист
  // поверх открытой шторки, в вебе — низкий лист (канон NATIVE-SLIDE §11: вторые уровни
  // и простые панели — нижним листом).
  const openNeedChannel = useCallback(() => {
    // Свежая сборка — РОДНОЙ низкий лист теми же словами (волна 3).
    if (hasNativeNotice()) {
      void showNativeNotice({
        style: 'sheet',
        title: t('notifUrgentKeepTitle'),
        text: t('notifUrgentKeepBody'),
        primary: tc('close'),
        // ВИБРАЦИЯ ОТКАЗА (владелец 10.09.2026, скрин 11:42): тумблер возвращался молча.
        // Отказ решает ВЕБ (правило «оставьте хотя бы один способ» живёт здесь), поэтому
        // и вибрацию просит он — оболочка даёт её в тот же миг, что и лист.
        haptic: 'error',
      });
      return;
    }
    panel.open({
      title: t('notifUrgentKeepTitle'),
      sheet: true,
      sheetDetent: 0.4,
      body: (
        <DGroup>
          <DHint>{t('notifUrgentKeepBody')}</DHint>
        </DGroup>
      ),
    });
  }, [panel, t, tc]);

  // «Финансовые»: тот же отказ, свои слова (только веб — в приложении группы нет).
  const openNeedFinance = useCallback(() => {
    panel.open({
      title: t('notifUrgentKeepTitle'),
      sheet: true,
      sheetDetent: 0.4,
      body: (
        <DGroup>
          <DHint>{t('notifFinanceKeepBody')}</DHint>
        </DGroup>
      ),
    });
  }, [panel, t]);

  const ensurePush = useCallback(async (): Promise<boolean> => {
    if (!native) return true;
    if (pushRef.current === 'granted') return true;
    if (pushRef.current === 'denied') {
      openPushDenied();
      return false;
    }
    const r = await nativeBridge()
      ?.requestPushPermission?.()
      .catch(() => null);
    if (r) setPush(r.status);
    if (r?.status !== 'granted') return false;
    void syncPushToken();
    return true;
  }, [native, openPushDenied, setPush]);

  // Оптимистичная запись: подменяем кэш, при неудаче возвращаем прежнее (как везде в кабинете).
  // Считаем от СВЕЖИХ данных из ref, а не от замыкания: тело модалки — отдельный слой,
  // и второе переключение подряд иначе затёрло бы первое старым снимком кэша.
  const applyTypes = useCallback(
    async (build: (cur: Types) => Types, payload: Record<string, unknown>): Promise<boolean> => {
      const prev = dataRef.current;
      const cur = readTypes(prev?.types);
      if (!cur) return false;
      const next = { ...(prev ?? {}), ok: true, types: build(cur) };
      dataRef.current = next;
      mutate(next);
      const res = await save(payload);
      if (!res.ok && prev) {
        dataRef.current = prev;
        mutate(prev);
      }
      return res.ok;
    },
    [mutate, save],
  );

  const setChannels = useCallback(
    (kind: ChKind, next: ChSet): Promise<boolean> =>
      applyTypes((cur) => ({ ...cur, [kind]: next }), { type: kind, channels: next }),
    [applyTypes],
  );

  // «Важные» пишутся тем же путём, но отказ сервера «остался бы ноль каналов» —
  // не «не получилось», а объяснение: ловим его и показываем модалку. Замок стоит и в
  // модалке (до отправки), и здесь: правка могла прилететь из второго окна кабинета.
  const setUrgent = useCallback(
    async (next: ChSet): Promise<boolean> => {
      if (urgentWouldEmpty(next)) {
        openNeedChannel();
        return false;
      }
      const prev = dataRef.current;
      const cur = readTypes(prev?.types);
      if (!cur) return false;
      const patched = { ...(prev ?? {}), ok: true, types: { ...cur, urgent: next } };
      dataRef.current = patched;
      mutate(patched);
      const res = await save({ type: 'urgent', channels: next });
      if (!res.ok) {
        if (prev) {
          dataRef.current = prev;
          mutate(prev);
        }
        if (res.error === 'need_one_channel') openNeedChannel();
      }
      return res.ok;
    },
    [mutate, openNeedChannel, save],
  );

  // «Финансовые» — тем же путём, что «Важные»: замок «минимум один способ» до отправки и
  // отказ сервера need_one_channel — объяснением. Пуша у этой группы нет вовсе.
  const setFinance = useCallback(
    async (next: FinSet): Promise<boolean> => {
      if (!next.tg && !next.email) {
        openNeedFinance();
        return false;
      }
      const prev = dataRef.current;
      const cur = readTypes(prev?.types);
      if (!cur) return false;
      const patched = { ...(prev ?? {}), ok: true, types: { ...cur, finance: next } };
      dataRef.current = patched;
      mutate(patched);
      const res = await save({ type: 'finance', channels: next });
      if (!res.ok) {
        if (prev) {
          dataRef.current = prev;
          mutate(prev);
        }
        if (res.error === 'need_one_channel') openNeedFinance();
      }
      return res.ok;
    },
    [mutate, openNeedFinance, save],
  );

  // ── ТИХИЕ ЧАСЫ ───────────────────────────────────────────────────────────────────
  // Настройка лежит НЕ в types (это не «тип уведомления», а расписание молчания), поэтому
  // своя оптимистичная запись — но по тем же правилам: считаем от свежего снимка из ref.
  const applyQuiet = useCallback(
    async (patch: Partial<QuietPrefs>): Promise<boolean> => {
      const prev = dataRef.current;
      const cur = readQuiet(prev?.quiet);
      if (!cur) return false;
      const next = { ...(prev ?? {}), ok: true, quiet: { ...cur, ...patch } };
      dataRef.current = next;
      mutate(next);
      const res = await save({ type: 'quiet', ...patch });
      if (!res.ok && prev) {
        dataRef.current = prev;
        mutate(prev);
      }
      return res.ok;
    },
    [mutate, save],
  );

  // Режим ОДНОГО аккаунта: на сервер уезжает РОВНО один ключ — тот, который человек и
  // менял (сервер сливает этот кусок с сохранённой картой). Выбор, совпавший с тем, что
  // аккаунт наследует от «Все аккаунты», личной записи не заводит, а заведённую когда-то
  // стирает (msgModeEdit шлёт null) — иначе аккаунт молча отвязывается от «Все аккаунты».
  const setMsgMode = useCallback(
    async (key: string, mode: MsgMode): Promise<boolean> => {
      const cur = readTypes(dataRef.current?.types);
      if (!cur) return false;
      const edit = msgModeEdit(cur.messages.modes, key, mode);
      // Менять нечего — и запроса нет: пустая правка не должна ни писать в базу, ни
      // возвращать «не вышло».
      if (!edit.patch) return true;
      return applyTypes((c) => ({ ...c, messages: { modes: edit.modes } }), {
        type: 'messages',
        modes: edit.patch,
      });
    },
    [applyTypes],
  );

  // Режим ВСЕМ аккаунтам разом: карта схлопывается в одно значение по умолчанию —
  // ровно так же, как это делает сервер по allMode. Схлопывание снимает и личные записи
  // аккаунтов, и «По умолчанию для новых аккаунтов»: сказано «всем» — значит всем,
  // включая те, что подключат позже (об этом и спрашивает подтверждение).
  const setMsgAll = useCallback(
    (mode: MsgMode): Promise<boolean> =>
      applyTypes((cur) => ({ ...cur, messages: { modes: { '*': mode } } }), {
        type: 'messages',
        allMode: mode,
      }),
    [applyTypes],
  );

  // СНЯТЬ ЗАПИСЬ ОТКЛЮЧЁННОГО АККАУНТА (Н2): подключения нет, а режим в карте остался —
  // человек убирает его сам. На сервер уезжает тот же null, что и при возврате аккаунта
  // к наследованию; строка исчезает вместе с записью (список строится из живых
  // подключений и записей карты).
  const forgetMsgAccount = useCallback(
    (key: string): Promise<boolean> =>
      applyTypes(
        (cur) => ({
          ...cur,
          messages: {
            modes: Object.fromEntries(Object.entries(cur.messages.modes).filter(([k]) => k !== key)),
          },
        }),
        { type: 'messages', modes: { [key]: null } },
      ),
    [applyTypes],
  );

  // ── Сводка строки серым: КОРОТКО, в одну строку (владелец 09.09.2026 — прежнее
  // «Пуш включён · Телеграм выключен · Почта включена» не влезало в строку и обрывалось
  // на «Пуш в…»). Пишем ВКЛЮЧЁННЫЕ каналы через запятую; все три — «Все», ни одного —
  // «Выкл.». Слова каналов те же, что у галочек, — второго словаря нет.
  const sumChannels = (c: { push?: boolean; tg: boolean; email: boolean }): string => {
    // Без поля push (веб, «Финансовые») считаем только два канала.
    const withPush = c.push !== undefined;
    if (!c.push && !c.tg && !c.email) return t('notifSumOff');
    if ((c.push || !withPush) && c.tg && c.email) return t('notifSumAll');
    return [
      ...(c.push ? [t('notifChPush')] : []),
      ...(c.tg ? [t('notifChTg')] : []),
      ...(c.email ? [t('notifChEmail')] : []),
    ].join(', ');
  };
  // Сводка сообщений — ЧЕТЫРЕ коротких слова (владелец 09.09.2026): «Все» / «Ручные» /
  // «Выкл.» / «Разные». Полные названия режимов остаются в листе выбора.
  const sumMessages = (m: MsgPrefs): string => {
    const one = oneMode(modeList(m.modes, accounts));
    if (one === null) return t('notifMsgMixed');
    return one === 'off' ? t('notifSumOff') : t(one === 'manual' ? 'notifSumMsgManual' : 'notifSumMsgAll');
  };
  // Сводка тихих часов — три честных случая (см. quietSummaryKind): выключено / пояс
  // ещё не определился (тишины НЕ будет, и молчать об этом нельзя) / промежуток.
  const sumQuiet = (q: QuietPrefs): string => {
    const kind = quietSummaryKind(q, tz);
    if (kind === 'off') return t('notifSumOff');
    if (kind === 'no-tz') return t('notifQuietNoTz');
    return t('notifQuietSum', { from: q.from, to: q.to });
  };

  const pushDenied = native && pushStatus === 'denied';
  const channels = useChannelRows()({
    email: data?.email ?? '',
    tgLinked: !!data?.tgLinked,
    tgBlocked: !!data?.tgBlocked,
    tgName: data?.tgName ?? null,
    pushDenied,
  });

  return {
    data: data ?? null,
    types,
    accounts,
    quiet,
    pushDenied,
    ensurePush,
    setChannels,
    setUrgent,
    setFinance,
    applyQuiet,
    setMsgMode,
    setMsgAll,
    forgetMsgAccount,
    openNeedChannel,
    openNeedFinance,
    sumChannels,
    sumMessages,
    sumQuiet,
    channels,
    curTypes: () => readTypes(dataRef.current?.types),
    curAccounts: () => readAccounts(dataRef.current?.accounts),
    curQuiet: () => readQuiet(dataRef.current?.quiet),
  };
}

/** ШТОРКИ страницы (тип доставки, сообщения людей, тихие часы) — тоже одной рукой: их
 *  открывает и строка веб-шторки, и тап по строке РОДНОЙ страницы приложения. */
export function useNotifyModals(p: NotifyPrefs): {
  openChannels: (kind: ChKind) => void;
  openFinance: () => void;
  openMessages: () => void;
  openQuiet: () => void;
} {
  const t = useTranslations('cabinet.settings');
  const panel = useSlidePanel();
  // ВЕБ: варианта «пуш» у групп нет (владелец 09.10.2026). Признак приложения — тот же,
  // что у строки «Сообщения» (UA приложения или метод моста родных страниц).
  const noPush = !(useNativeApp() || !!nativeMethod('accountOpen'));
  const tc = useTranslations('cabinet');
  // ЛИСТ ГРУППЫ НА ТЕЛЕФОНЕ В БРАУЗЕРЕ (владелец 09.10.2026): полулист с «×» слева (новый лист поверх,
  // не шаг вглубь) и круглой галочкой справа. Выбор — мультиселект и применяется сразу, тап по варианту
  // лист не закрывает; галочка шапки только закрывает лист. Тап мимо листа закрывает его (drawer.tsx).
  const groupSheet = () => ({
    sheet: true,
    sheetDetent: 0.52,
    lead: 'close' as const,
    actionLabel: tc('done'),
    actionIcon: 'checkmark',
    onAction: () => panel.close(),
  });

  const openChannels = (kind: ChKind) => {
    const initial = kind === 'urgent' ? p.types?.urgent : p.types?.[kind];
    if (!initial) return;
    panel.open({
      title: t(kind === 'marketing' ? 'notifMarketing' : 'notifUrgent'),
      // Боковая шторка (владелец 12.08: первый уровень — только горизонтально).
      // Галки в шапке нет (этап 6): выбор применяется сразу, из шторки уходят «назад».
      // Телефон в браузере (К7/К9, кадры iOS K04): лист-стопка с «×» — полулистом, как
      // родной (кадры K04-notif-news/-urgent: кромка листа на 0,52 высоты экрана снизу).
      ...(phoneWebNow() ? groupSheet() : {}),
      body: (
        <ChannelsModal
          initial={initial}
          email={p.data?.email ?? ''}
          tgLinked={!!p.data?.tgLinked}
          tgBlocked={!!p.data?.tgBlocked}
          tgName={p.data?.tgName ?? null}
          pushDenied={p.pushDenied}
          ensurePush={p.ensurePush}
          noPush={noPush}
          // «Важные» объясняются ДО галочек: человек должен понимать, что этот тип
          // приходит всегда, и почему один способ доставки обязан остаться.
          {...(kind === 'urgent'
            ? {
                intro: t('notifUrgentIntro'),
                // На телефоне вступления над галочками нет — сноска говорит всё сразу,
                // словами родной страницы (кадр iOS K04-notif-urgent).
                hint: phoneWebNow() ? t('notifUrgentNote') : t('notifUrgentKeep'),
                minOne: true,
                onBlocked: p.openNeedChannel,
              }
            : {})}
          onChange={(next) => (kind === 'urgent' ? p.setUrgent(next) : p.setChannels(kind, next))}
        />
      ),
    });
  };

  // ── Шторка «Финансовые» (только веб) — по образцу «Важных»: две галочки (Телеграм и
  // почта), последнюю снять нельзя. Пуша у платёжных нет и не будет.
  const openFinance = () => {
    const fin = p.curTypes()?.finance;
    if (!fin) return;
    panel.open({
      title: t('notifGroupFinance'),
      ...(phoneWebNow() ? groupSheet() : {}),
      body: (
        <ChannelsModal
          initial={{ push: false, ...fin }}
          email={p.data?.email ?? ''}
          tgLinked={!!p.data?.tgLinked}
          tgBlocked={!!p.data?.tgBlocked}
          tgName={p.data?.tgName ?? null}
          pushDenied={false}
          ensurePush={p.ensurePush}
          noPush
          intro={t('notifGroupFinanceHint')}
          hint={phoneWebNow() ? `${t('notifGroupFinanceHint')}. ${t('notifUrgentKeep')}` : t('notifUrgentKeep')}
          minOne
          onBlocked={p.openNeedFinance}
          onChange={(next) => p.setFinance({ tg: next.tg, email: next.email })}
        />
      ),
    });
  };

  // Данные берём из ref, а не из замыкания рендера: этой же рукой шторка ОТКРЫВАЕТСЯ
  // ЗАНОВО в вебе при возврате из низкой шторки режима (drawer не держит стопку) —
  // и должна показать уже применённые режимы.
  const openMessages: () => void = () => {
    const cur = p.curTypes();
    if (!cur) return;
    panel.open({
      // Боковая шторка (владелец 12.08: первый уровень — только горизонтально);
      // низкая шторка режима аккаунта внутри остаётся нижним листом. Галки в шапке нет
      // (этап 6): режим применяется сразу, из шторки уходят «назад».
      title: t('notifMessages'),
      ...(phoneWebNow() ? { sheet: true } : {}),
      body: (
        <MessagesModal
          initial={cur.messages}
          accounts={p.curAccounts()}
          onSet={p.setMsgMode}
          onSetAll={p.setMsgAll}
          onForget={p.forgetMsgAccount}
          ensurePush={p.ensurePush}
        />
      ),
    });
  };

  // ── Шторка «Тихие часы» ───────────────────────────────────────────────────────────
  // Первый уровень, поэтому — БОКОВАЯ шторка, как у типов (владелец 12.08). Внутри
  // тумблер, границы времени и вторая дверь часового пояса; галки в шапке нет — всё
  // применяется сразу.
  const openQuiet: () => void = () => {
    const cur = p.curQuiet();
    if (!cur) return;
    panel.open({
      title: t('notifQuiet'),
      // Телефон в браузере: «Тихие часы» — СТРАНИЦА СТОПКИ (горизонтально, «‹» и имя в
      // шапке), а не лист: так у родной страницы (кадр iOS K04-notif-quiet).
      ...(phoneWebNow() ? { sheet: false } : {}),
      body: <QuietModal initial={cur} onChange={p.applyQuiet} />,
    });
  };

  return { openChannels, openFinance, openMessages, openQuiet };
}

export function NotificationsSheet() {
  const t = useTranslations('cabinet.settings');
  const p = useNotifyPrefs();
  const { openChannels, openFinance, openMessages, openQuiet } = useNotifyModals(p);
  const { types, quiet } = p;
  // «СООБЩЕНИЯ» — ТОЛЬКО В ПРИЛОЖЕНИИ (владелец 10.09.2026, второй обход). У этой
  // настройки один способ доставки — пуш на телефон, а пушей в браузере у нас нет
  // вовсе: в вебе строка вела на настройку, которая ни на что не влияет. Признак — тот
  // же, что везде в кабинете (UA приложения), плюс метод моста родных страниц: старые
  // сборки без метода настройку тоже показывают, пуши у них есть.
  const inApp = useNativeApp() || !!nativeMethod('accountOpen');
  // Телефон в браузере (ТЗ WEB-PARITY-3 К10, кадр iOS K04-notifications): без подписи «Что
  // присылать», значения строк — справа серым.
  const phoneWeb = usePhoneLook();
  const side = (v: ReactNode) => (phoneWeb ? { value: v } : { summary: v });

  // ── Шторка «Полученные» ───────────────────────────────────────────────────────────
  // Рука ОБЩАЯ (useOpenInbox): этой же строкой центр открывает колокольчик шапки
  // «Аккаунта» — второй механики открытия в кабинете нет.

  // Вид владельца (29.08): строки «Полученные» в теле больше НЕТ — центр открывает
  // круглая кнопка-колокольчик в углу шапки страницы (InboxTopButton ниже, она же
  // уходит в родную шапку приложения через action свода). Тело страницы — только
  // настройки: пузырь «Что присылать» со строками-типами БЕЗ тумблеров (все настройки
  // внутри шторки типа) и «Тихие часы».
  return (
    <FPane>
      <FNotifyList
        {...(phoneWeb ? {} : { label: t('notifWhatHead') })}
        // Настройки ещё едут — пузырь держит место, но не рисуется (Н17: скелетонов нет).
        className={types ? undefined : 'sk-hold'}
        items={
          types
            ? [
                {
                  key: 'marketing',
                  label: t('notifMarketing'),
                  icon: <MegaphoneGlyph />,
                  iconColor: 'var(--violet)',
                  ...side(p.sumChannels(inApp ? types.marketing : { tg: types.marketing.tg, email: types.marketing.email })),
                  onOpen: () => openChannels('marketing'),
                },
                // Строка есть только в приложении (см. inApp выше): доставка у неё одна —
                // пуш, а в браузере пушей нет.
                ...(inApp
                  ? [
                      {
                        key: 'messages',
                        label: t('notifMessages'),
                        icon: <BubbleGlyph />,
                        iconColor: 'var(--green)',
                        ...side(p.sumMessages(types.messages)),
                        onOpen: openMessages,
                      },
                    ]
                  : []),
                // «Важные» — последней строкой пузыря: отключить их нельзя, можно только
                // выбрать, куда они придут. Строки нет вовсе, пока в ответе нет каналов
                // (кэш с прошлой выкатки) — пустую настройку не рисуем.
                ...(types.urgent
                  ? [
                      {
                        key: 'urgent',
                        label: t('notifUrgent'),
                        icon: <ShieldGlyph />,
                        iconColor: 'var(--amber)',
                        ...side(p.sumChannels(inApp ? types.urgent : { tg: types.urgent.tg, email: types.urgent.email })),
                        onOpen: () => openChannels('urgent'),
                      },
                    ]
                  : []),
                // «Финансовые» (владелец 09.10.2026) — ТОЛЬКО В ВЕБЕ, последней строкой:
                // оплата, продление, списания с карты, чеки; почта и Телеграм. В приложении
                // денег нет (запрет №7) — строки нет вовсе.
                ...(!inApp && types.finance
                  ? [
                      {
                        key: 'finance',
                        label: t('notifGroupFinance'),
                        icon: <CardGlyph />,
                        iconColor: 'var(--blue)',
                        ...side(p.sumChannels(types.finance)),
                        onOpen: openFinance,
                      },
                    ]
                  : []),
              ]
            : // Тихая деградация: настройки ещё не пришли — вместо полупустой формы скелетон.
              // С плиткой значка: иначе на приходе данных строки прыгают вбок.
              [0, 1].map((i) => ({
                key: String(i),
                icon: <Sk w={20} h={20} r="round" />,
                label: <Sk w={150} h={14} />,
                summary: <Sk w={110} h={12} />,
                onOpen: () => {},
              }))
        }
      />
      {/* ТИХИЕ ЧАСЫ — отдельным пузырём-строкой: это не «что присылать», а КОГДА молчать.
          Стоит под настройками типов, потому что уточняет их все разом. */}
      <FNotifyList
        className={quiet ? undefined : 'sk-hold'}
        items={[
          quiet
            ? {
                key: 'quiet',
                label: t('notifQuiet'),
                icon: <MoonGlyph />,
                iconColor: 'var(--violet)',
                ...side(p.sumQuiet(quiet)),
                onOpen: openQuiet,
              }
            : {
                key: 'quiet',
                icon: <Sk w={20} h={20} r="round" />,
                label: <Sk w={110} h={14} />,
                summary: <Sk w={140} h={12} />,
                onOpen: () => {},
              },
        ]}
      />
    </FPane>
  );
}

// ─────────────── РОДНАЯ СТРАНИЦА «УВЕДОМЛЕНИЯ» (этап В; переделана в волне 3) ───────────────
//
// СТРАНИЦА — КОПИЯ ВЕБ-ЭКРАНА (аудит халявы, docs/NATIVE-TABS-PLAN.md, волна 3): пузырь
// «Что присылать» с тремя СТРОКАМИ-ПЕРЕХОДАМИ (плитка значка своего цвета + сводка
// текущих настроек), отдельным пузырём — «Тихие часы», колокольчик «Полученные» —
// КРУГЛОЙ КНОПКОЙ В УГЛУ ШАПКИ (строки в теле нет, владелец 29.08.2026).
//
// Прежние развёрнутые тумблеры каналов со страницы СНЯТЫ: в вебе их там нет, настройки
// живут в шторке типа. Четыре веб-шторки первого уровня — БОКОВЫЕ, поэтому в приложении
// это СТРАНИЦЫ СТОПКИ (канон: где веб открывает боковую шторку, натив открывает
// страницу, а не нижний лист). Нижним листом остаётся только выбор режима аккаунта —
// в вебе он тоже низкая шторка второго уровня.
//
// Пишут страницы ТЕ ЖЕ руки (useNotifyPrefs), что и веб-шторки: второй правды о
// настройке в кабинете нет.

/** Ключи строк родной страницы: приставка своя, чтобы не столкнуться со строками
 *  соседних страниц раздела (ключ уникален в пределах «Аккаунта»). */
const NOTIF_ROW = {
  inbox: 'notif:inbox',
  marketing: 'notif:marketing',
  messages: 'notif:messages',
  urgent: 'notif:urgent',
  quiet: 'notif:quiet',
} as const;

/**
 * РОДНЫЕ ПОДСТРАНИЦЫ «УВЕДОМЛЕНИЙ» — БЕЗ АДРЕСА (как страницы свода «Настроек»): в вебе
 * это боковые шторки, а шторка адреса не меняла. Стопку держит у себя веб
 * (AccountPagesPanel) и отдаёт нативу тем же полем `stack`.
 *
 * INVARIANT(scriptera): ключ отсюда в приложении НЕ открывает веб-шторку — иначе поверх
 * родной страницы встанет её же веб-копия. Канон: docs/NATIVE-TABS-PLAN.md, волна 3.
 */
export const NATIVE_NOTIFY_PAGE_KEYS: ReadonlySet<string> = new Set([
  NOTIF_ROW.marketing,
  NOTIF_ROW.messages,
  NOTIF_ROW.urgent,
  NOTIF_ROW.quiet,
]);

/** Приставка ключей строк выбора режима: 'notif:msg:<ключ аккаунта>'. */
const MSG_ROW = 'notif:msg:';
/** Значение кнопки «Убрать из списка» в родном листе режима (в вебе — та же кнопка).
 *  Пробел внутри не даст ему совпасть ни с одним режимом. */
const MSG_FORGET = ' forget';

/** Плитки значков строк — ТЕ ЖЕ, что в вебе (мегафон фиолетовый, пузырь зелёный, щит
 *  янтарный, месяц фиолетовый): SF-символы того же рисунка, цвета — роли палитры. */
const NOTIF_ICON = {
  marketing: 'megaphone',
  messages: 'text.bubble',
  urgent: 'exclamationmark.shield',
  quiet: 'moon',
  all: 'square.grid.2x2',
  newAcc: 'plus.circle',
} as const;

export function useNativeNotifyPage(
  key: string,
  title: string,
  meta: string,
  /** Что открыто прямо сейчас: тяжёлый список поясов едет мостом, только пока открыты
   *  «Тихие часы» (иначе каждый патч таскал бы сотни рядов зря). */
  stack: string[],
): {
  pages: NativeAccountPage[];
  applySet: (rowKey: string, value: string | boolean) => boolean;
  tapRow: (rowKey: string) => boolean;
} {
  const t = useTranslations('cabinet.settings');
  const tc = useTranslations('cabinet');
  const locale = useLocale();
  const p = useNotifyPrefs();
  const openInbox = useOpenInbox();
  const unread = useInboxBadge();
  const tz = useTimezoneSetting();
  // ОТКАЗ НАДО ПОКАЗАТЬ. Родная строка отмечается СРАЗУ (галочка, выбранный режим), а
  // веб иногда правку не берёт вовсе: снят последний способ доставки «Важных», система
  // не дала разрешения на пуш. Данные при этом не менялись — значит и патч был бы тем
  // же, и натив остался бы с чужой галочкой. Этот счётчик меняет отпечаток страницы, и
  // она пересобирается из ПРАВДЫ.
  const [refused, setRefused] = useState(0);
  const refuse = () => setRefused((n) => n + 1);
  const { types, quiet, accounts, channels } = p;
  const quietOpen = stack.includes(NOTIF_ROW.quiet);

  // ЛИЦА АККАУНТОВ — ТЕМ ЖЕ КОНВЕЙЕРОМ, ЧТО КРУЖКИ «АНАЛИТИКИ» И ФОТО «ЧАТОВ» (base64,
  // уменьшенные): клиент ничего не качает сам, картинку готовит веб. Пустая строка в
  // словаре — фото не взялось (нет его, обрыв): строка рисует плитку канала, а ожидание
  // не виснет. Второго конвейера картинок для натива не заводим (avatar.tsx).
  const [photos, setPhotos] = useState<Record<string, string>>({});
  const photoUrls = accounts.flatMap((a) => (a.avatar ? [a.avatar] : []));
  const photoKey = photoUrls.join('|');
  useEffect(() => {
    if (!photoKey) return;
    // Уже собранное не качаем заново: словарь в зависимостях, и после каждой добавки
    // проход повторяется — но забирать ему уже нечего и он выходит сразу.
    const want = photoKey.split('|').filter((u) => photos[u] === undefined);
    if (want.length === 0) return;
    let dead = false;
    void (async () => {
      const pairs = await Promise.all(
        // Лица людей — JPEG 64 (SCALE-PLAN Е1): килобайты через мост вместо десятков.
        want.map(async (u) => [u, (await imgSquarePng(u, 64, { format: 'jpeg', quality: 0.8 })) ?? ''] as const),
      );
      if (dead) return;
      setPhotos((prev) => ({ ...prev, ...Object.fromEntries(pairs) }));
    })();
    return () => {
      dead = true;
    };
  }, [photoKey, photos]);

  // ── СТРАНИЦА «УВЕДОМЛЕНИЯ»: пузырь «Что присылать» и пузырь «Тихие часы».
  // ПОРЯДОК ПУЗЫРЕЙ ПОСТОЯНЕН, а пустой пузырь ждёт свои строки (тот же приём, что у
  // «Тарифа»): данные доезжают — строки встают на свои места, страница не прыгает.
  const groups: NativeAccountGroup[] = [
    {
      // Заголовка «Что присылать» у пузыря НЕТ (владелец 09.09.2026): герой страницы уже
      // сказал, о чём она, а у Apple первая группа настроек идёт без подписи.
      key: 'what',
      fields: types
        ? [
            {
              key: NOTIF_ROW.marketing,
              kind: 'nav' as const,
              title: t('notifMarketing'),
              icon: NOTIF_ICON.marketing,
              color: accountRoleHex('var(--violet)'),
              value: p.sumChannels(types.marketing),
            },
            {
              key: NOTIF_ROW.messages,
              kind: 'nav' as const,
              title: t('notifMessages'),
              icon: NOTIF_ICON.messages,
              color: accountRoleHex('var(--green)'),
              value: p.sumMessages(types.messages),
            },
            // «Важные» — последней строкой пузыря; строки нет вовсе, пока в ответе нет
            // каналов (кэш с прошлой выкатки), ровно как в вебе.
            ...(types.urgent
              ? [
                  {
                    key: NOTIF_ROW.urgent,
                    kind: 'nav' as const,
                    title: t('notifUrgent'),
                    icon: NOTIF_ICON.urgent,
                    color: accountRoleHex('var(--amber)'),
                    value: p.sumChannels(types.urgent),
                  },
                ]
              : []),
          ]
        : [],
    },
    // ТИХИЕ ЧАСЫ — отдельным пузырём-строкой без имени: это не «что присылать», а КОГДА
    // молчать (владелец 2026-08-21). Стоит под настройками типов, как в вебе.
    {
      key: 'quiet',
      fields: quiet
        ? [
            {
              key: NOTIF_ROW.quiet,
              kind: 'nav' as const,
              title: t('notifQuiet'),
              icon: NOTIF_ICON.quiet,
              color: accountRoleHex('var(--violet)'),
              value: p.sumQuiet(quiet),
            },
          ]
        : [],
    },
  ];

  const page: NativeAccountPage = {
    key,
    title,
    hero: { icon: 'bell', color: accountRoleHex('var(--amber)'), title, meta },
    // «Полученные» — круглая кнопка в углу шапки с наклейкой непрочитанного (владелец
    // 29.08.2026): та же кнопка, что стоит в шапке веб-страницы (InboxTopButton).
    action: {
      key: NOTIF_ROW.inbox,
      // Значок ровно тот же, что у веб-кнопки, а непрочитанное показывает НАКЛЕЙКА-ЦИФРА
      // (в вебе — та же розовая пилюля): второй пометки на одном значке не заводим.
      icon: 'bell',
      ...(unread > 0 ? { badge: unread > 99 ? '99+' : String(unread) } : {}),
    },
    // Настройки ещё едут — страница ждёт их пустым пузырём, а не показывает половину
    // строк и не перекрашивает их на приходе данных (дёрганья запрещены).
    loading: !types,
    groups,
  };

  // ── ПОДСТРАНИЦА «Новости» / «Важные» (веб: ChannelsModal): один пузырь с ГАЛОЧКАМИ и
  // фактом под каждой (@имя телеграма, адрес почты). Ни заголовка группы, ни вступления:
  // страница о трёх галочках, объяснять нечего (владелец 09.09.2026). У «Важных» под
  // пузырём одна сноска — почему их нельзя выключить совсем.
  const channelsPage = (kind: ChKind, cur: ChSet): NativeAccountPage => ({
    key: kind === 'urgent' ? NOTIF_ROW.urgent : NOTIF_ROW.marketing,
    title: t(kind === 'marketing' ? 'notifMarketing' : 'notifUrgent'),
    // ПОЛУШТОРКА СНИЗУ (словарь видов §11.0): три галочки — короткий выбор, после
    // которого остаёшься на месте; вся страница видна на половине экрана. Старые сборки
    // слова не знают и открывают её горизонтально, как раньше (запасной ход).
    present: 'half',
    groups: [
      {
        key: `where-${refused}`,
        ...(kind === 'urgent' ? { hint: t('notifUrgentNote') } : {}),
        // Галочки, а не тумблеры: в вебе это пузырь выбора (FChoiceManyBlock).
        // Подписи и сведения (адрес почты, имя телеграм-аккаунта, «бот не привязан»,
        // отказ системного пуша) — ОБЩЕЙ рукой useChannelRows, что и у веб-модалки.
        fields: channels.map((c) => ({
          key: `notif:${kind}:${c.value}`,
          kind: 'check' as const,
          title: c.label,
          on: cur[c.value],
          ...(c.hint ? { hint: c.hint } : {}),
        })),
      },
    ],
  });

  // ── ПОДСТРАНИЦА «Сообщения пользователей» (веб: MessagesModal): «Все аккаунты»,
  // «По умолчанию для новых аккаунтов» и строка на каждый аккаунт со своей сводкой.
  // Тап по строке открывает НИЗКИЙ лист режима — в вебе это тоже нижний лист.
  const modeOptions = [
    { value: 'all', label: t('notifMsgScopeAll'), hint: t('notifMsgScopeAllHint') },
    { value: 'manual', label: t('notifMsgScopeManual'), hint: t('notifMsgManualHint') },
    { value: 'off', label: t('notifMsgScopeNone'), hint: t('notifMsgScopeNoneHint') },
  ];
  const word = (m: MsgMode) => t(modeKey(m));
  const messagesPage = (cur: MsgPrefs): NativeAccountPage => {
    // СПИСОК = РЕАЛЬНОСТЬ (Н2): живые подключения + осиротевшие записи карты.
    const rows = msgSettingsAccounts(accounts, cur.modes);
    const one = oneMode(modeList(cur.modes, rows));
    const modeRow = (
      rowKey: string,
      label: string,
      summary: string,
      look: { icon?: string; color?: string; image?: string; photo?: string; titleImage?: string; titleImageColor?: string },
      extra: { hint?: string; forget?: boolean; below?: boolean } = {},
    ): NativeAccountField => ({
      key: `${MSG_ROW}${rowKey}`,
      kind: 'choice',
      title: label,
      ...look,
      // СТРОКА «ЗАГОЛОВОК + ПОДЗАГОЛОВОК + ШЕВРОН» (владелец 09.09.2026, общее правило
      // П3 волны 2): у аккаунта длинное имя, и режим справа с ним не помещался («Работ…»).
      // Режим уходит ВТОРОЙ строкой под имя, справа остаётся только шеврон — значение
      // (`value`) такой строке не шлём вовсе. У коротких строк свода всё как было.
      ...(extra.below ? { hint: summary } : { value: summary }),
      picked: msgModeShown(cur.modes, rowKey),
      options: modeOptions,
      // ИМЕНИ У ПУЗЫРЯ ВЫБОРА НЕТ (владелец 10.09.2026, второй обход): «Какие переписки»
      // — разговорная формулировка, а в заголовках над пузырями таких не бывает. Имя
      // строки уже стоит в шапке листа, второй раз объяснять выбор нечем.
      ...(extra.hint ? { pickHint: extra.hint } : {}),
      // У отключённого аккаунта в листе ещё и кнопка «убрать из списка» — как в вебе.
      ...(extra.forget ? { pickAction: { label: t('notifMsgForget'), value: MSG_FORGET } } : {}),
    });
    return {
      key: NOTIF_ROW.messages,
      title: t('notifMessages'),
      // ТРИ ПУЗЫРЯ (владелец 10.09.2026, обход приложения; отменяет «два пузыря» 09.09):
      // «Все аккаунты» и «Новые аккаунты» стояли в ОДНОМ пузыре без подписей, и клиент не
      // понимал, чем строки отличаются. Теперь у каждой свой пузырь со своей серой
      // подписью под ним, а список аккаунтов — третьим, как был.
      groups: [
        // ОПИСАНИЕ СТРАНИЦЫ ТЕКСТОМ (владелец 10.09.2026, канон Apple): абзац под шапкой,
        // слева, без значка — та же пустая группа с подписью, что у «Тихих часов».
        { key: 'intro', hint: t('notifMsgIntro'), fields: [] },
        {
          // Заголовка у пузыря нет (владелец 09.09.2026): название страницы уже сказало,
          // о чём она. Подпись под пузырём говорит, что строка меняет ВСЁ сразу.
          key: `all-${refused}`,
          hint: t('notifMsgAllHint'),
          fields: [
            modeRow(
              '*',
              t('notifMsgAll'),
              // Один режим у всех — он же и написан; разнобой — «Разные».
              one === null ? t('notifMsgMixed') : word(one),
              { icon: NOTIF_ICON.all, color: accountRoleHex('var(--violet)') },
            ),
          ],
        },
        {
          // ВТОРОЙ ПУЗЫРЬ — «Новые аккаунты»: та же подпись, что и внутри листа выбора
          // (pickHint), но видна СРАЗУ — пояснения в кабинете не прячем.
          key: `new-${refused}`,
          hint: t('notifMsgNewHint'),
          fields: [
            modeRow(
              MSG_MODE_NEW,
              t('notifMsgNew'),
              word(msgModeShown(cur.modes, MSG_MODE_NEW)),
              { icon: NOTIF_ICON.newAcc, color: accountRoleHex('var(--green)') },
              { hint: t('notifMsgNewHint') },
            ),
          ],
        },
        // ТРЕТИЙ ПУЗЫРЬ — САМИ АККАУНТЫ, с заголовком «Аккаунты». Аккаунтов нет вовсе —
        // пузыря нет: пустая рамка с заголовком ничего не говорит.
        ...(rows.length > 0
          ? [
              {
                key: `accounts-${refused}`,
                label: t('notifMsgAccounts'),
                fields: rows.map((a) =>
                  modeRow(
                    a.key,
                    a.name,
                    // Отключённый аккаунт — одно слово «Отключён»: режим у него уже ни на
                    // что не влияет (владелец 09.09.2026).
                    a.off ? t('notifAccOff') : word(msgModeShown(cur.modes, a.key)),
                    // ЛИЦО АККАУНТА (владелец 02.09.2026): фотография инстаграм-аккаунта
                    // или бота. Нет её или не взялась — знак сети фирменной картинкой
                    // каталога сборки (чужой знак не перекрашиваем), как запаска веб-строки.
                    // ЗНАК СЕТИ ПЕРЕД ЛОГИНОМ (владелец 10.09.2026: «значки социальных
                    // сетей надо поставить, перед логином») — `titleImage`, ОТДЕЛЬНО от
                    // лица: `image` был запаской ВМЕСТО фото, а знак нужен РЯДОМ с именем.
                    // ЗНАК СЕТИ — ПОСЛЕ ЛОГИНА, ТОТ ЖЕ, ЧТО У НАЗВАНИЯ БОТА НА «БОТАХ»
                    // (владелец 19.09.2026): картинка `QuickTile-<сеть>` цветом сети.
                    {
                      image: a.channel === 'ig' ? 'ChanIG' : 'ChanTG',
                      titleImage: nativeChannelTile(a.channel === 'ig' ? 'instagram' : 'telegram').icon,
                      titleImageColor: channelHex(a.channel === 'ig' ? 'instagram' : 'telegram'),
                      ...(a.avatar && photos[a.avatar] ? { photo: photos[a.avatar] } : {}),
                    },
                    { below: true, ...(a.off ? { hint: t('notifMsgOffHint'), forget: true } : {}) },
                  ),
                ),
              },
            ]
          : []),
      ],
    };
  };

  // ── ПОДСТРАНИЦА «Тихие часы» (веб: QuietModal): ТРИ ПУЗЫРЯ, у каждого свой заголовок
  // и/или своя сноска (владелец 09.09.2026, обход после сборки 173) — «Ночь» с тумблером,
  // границы времени и часовой пояс. Пояс тут — ВТОРАЯ ДВЕРЬ той же настройки, что «Язык
  // и регион» (общая рука useTimezoneSetting).
  const quietPage = (cur: QuietPrefs): NativeAccountPage => ({
    key: NOTIF_ROW.quiet,
    title: t('notifQuiet'),
    groups: [
      // ОПИСАНИЕ СТРАНИЦЫ ТЕКСТОМ (владелец 10.09.2026, канон Apple): абзац под шапкой над
      // первой группой, без значка и названия, слева — как вступления страниц «Настроек»
      // iOS. Пустая группа с подписью и есть такой абзац (натив рисует её обычной подписью).
      { key: 'intro', hint: t('notifQuietIntro'), fields: [] },
      {
        // ПУЗЫРЬ 1 — сам запрет: заголовок «Ночь» над ним; что именно молчит — сказано во
        // вступлении страницы, второй раз под тумблером не повторяем.
        key: 'quiet',
        label: t('notifQuietNight'),
        fields: [
          {
            // Тумблер БЕЗ абзаца под собой: что он делает, видно по имени страницы и
            // границам времени под ним.
            key: 'notif:quiet:on',
            kind: 'switch',
            title: t('notifQuietOn'),
            on: cur.enabled,
          },
        ],
      },
      // ПУЗЫРЬ 2 — границы времени, ОТДЕЛЬНЫЙ (владелец 09.09.2026): выключили ночь —
      // исчезает пузырь целиком, вместе со своей сноской, а не часть строк внутри
      // общего пузыря. Заголовка у него нет: «С» и «До» говорят сами за себя.
      ...(cur.enabled
        ? [
            {
              key: 'quiet-time',
              hint: t('notifQuietTimeNote'),
              fields: [
                {
                  key: 'notif:quiet:from',
                  kind: 'nav' as const,
                  title: t('notifQuietFrom'),
                  value: cur.from || QUIET_FROM,
                },
                {
                  key: 'notif:quiet:to',
                  kind: 'nav' as const,
                  title: t('notifQuietTo'),
                  value: cur.to || QUIET_TO,
                },
              ],
            },
          ]
        : []),
      {
        // ПОЯС: под НАЗВАНИЕМ строки абзаца нет, объяснение стоит СНОСКОЙ под пузырём
        // (владелец 09.09.2026). Слова — те же, что у поля TimezoneField веб-шторки.
        key: 'tz',
        hint: tz.unknown ? t('notifQuietTzUnknown') : t('notifQuietTzHint'),
        ...(tz.failed ? { status: { text: t('timezoneError'), bad: true } } : {}),
        fields: [
          {
            key: 'notif:quiet:tz',
            kind: 'choice',
            title: t('timezone'),
            value: tz.value ? zoneLabel(tz.value) : t('timezoneEmpty'),
            picked: tz.value,
            ...(quietOpen
              ? { options: tz.options.map((o) => ({ value: o.value, label: o.label, hint: o.desc })) }
              : {}),
            search: t('timezoneSearchPh'),
          },
        ],
      },
    ],
  });

  const pages: NativeAccountPage[] = [page];
  if (types) {
    pages.push(channelsPage('marketing', types.marketing));
    if (types.urgent) pages.push(channelsPage('urgent', types.urgent));
    pages.push(messagesPage(types.messages));
  }
  if (quiet) pages.push(quietPage(quiet));

  /** Галочка канала: тот же путь, что у веб-модалки, включая спрос разрешения на пуш и
   *  замок «Важных» (последний способ снять нельзя). */
  const applyChannel = (rowKey: string, value: boolean): boolean => {
    const m = /^notif:(marketing|urgent):(push|tg|email)$/.exec(rowKey);
    if (!m) return false;
    const kind = m[1] as ChKind;
    const ch = m[2] as 'push' | 'tg' | 'email';
    void (async () => {
      const curTypes = p.curTypes();
      const cur = kind === 'urgent' ? curTypes?.urgent : curTypes?.[kind];
      if (!cur) return;
      const next: ChSet = { ...cur, [ch]: value };
      if (kind === 'urgent' && urgentWouldEmpty(next)) {
        p.openNeedChannel();
        refuse(); // галочку, которую натив уже поставил, возвращаем к правде
        return;
      }
      // Пуш включается только после системного разрешения (отказ объясняет ensurePush).
      if (ch === 'push' && value && !cur.push && !(await p.ensurePush())) {
        refuse();
        return;
      }
      await (kind === 'urgent' ? p.setUrgent(next) : p.setChannels(kind, next));
    })();
    return true;
  };

  /** Режим аккаунта из родного листа: та же механика, что у веб-листа ModeSheet. */
  const applyMode = (rowKey: string, value: string): boolean => {
    const accKey = rowKey.slice(MSG_ROW.length);
    // «Убрать из списка» — кнопка того же листа (осиротевшая запись отключённого).
    if (value === MSG_FORGET) {
      void p.forgetMsgAccount(accKey);
      return true;
    }
    const mode: MsgMode = value === 'off' ? 'off' : value === 'manual' ? 'manual' : 'all';
    void (async () => {
      const curTypes = p.curTypes();
      if (!curTypes) return;
      const rows = msgSettingsAccounts(p.curAccounts(), curTypes.messages.modes);
      const allOff = oneMode(modeList(curTypes.messages.modes, rows)) === 'off';
      // Включение из полного молчания сперва спрашивает системное разрешение на пуш.
      if (mode !== 'off' && allOff && !(await p.ensurePush())) {
        refuse(); // режим, который натив уже показал, возвращаем к правде
        return;
      }
      if (accKey !== '*') {
        await p.setMsgMode(accKey, mode);
        return;
      }
      // «Все аккаунты» — через подтверждение, как в вебе (там ConfirmInline, в
      // приложении это то же родное окно iOS).
      if (!hasNativeConfirm()) {
        await p.setMsgAll(mode);
        return;
      }
      const yes = await askNativeConfirm({
        question: t('notifMsgAllQ'),
        confirmLabel: tc('common.done'),
        cancelLabel: tc('cancel'),
        destructive: false,
      });
      if (yes) await p.setMsgAll(mode);
      else refuse(); // отказались — строка обязана вернуться к прежнему режиму
    })();
    return true;
  };

  const applySet = (rowKey: string, value: string | boolean): boolean => {
    if (typeof value === 'boolean') {
      if (rowKey === 'notif:quiet:on') {
        void p.applyQuiet({ enabled: value });
        return true;
      }
      return applyChannel(rowKey, value);
    }
    if (rowKey === 'notif:quiet:tz') {
      tz.save(value);
      return true;
    }
    if (rowKey.startsWith(MSG_ROW)) return applyMode(rowKey, value);
    return false;
  };

  /** Границы тишины — РОДНЫМ КОЛЕСОМ ВРЕМЕНИ (общая рука pickNativeTime: её же зовёт
   *  поле TimePick веб-шторки). Своего выбора времени тут не заводим. */
  const pickQuietTime = (which: 'from' | 'to') => {
    const cur = p.curQuiet();
    if (!cur) return;
    const now = (which === 'from' ? cur.from : cur.to) || (which === 'from' ? QUIET_FROM : QUIET_TO);
    void pickNativeTime({
      value: now,
      locale,
      title: t(which === 'from' ? 'notifQuietFrom' : 'notifQuietTo'),
      doneLabel: tc('common.done'),
    }).then((picked) => {
      if (picked) void p.applyQuiet({ [which]: picked });
    });
  };

  const tapRow = (rowKey: string): boolean => {
    if (rowKey === NOTIF_ROW.inbox) {
      // ЖУРНАЛ (канон DIAGNOSTICS-CANON): веб принял ключ колокольчика страницы. Пара к
      // родным строкам «тап кнопки» и «accountTap» — по трём видно, где обрывается путь.
      journalLog('notify.inbox.tap', { row: rowKey });
      openInbox();
      return true;
    }
    if (rowKey === 'notif:quiet:from' || rowKey === 'notif:quiet:to') {
      pickQuietTime(rowKey === 'notif:quiet:from' ? 'from' : 'to');
      return true;
    }
    // Подстраницу натив уже открыл сам — вебу остаётся запомнить стопку (это делает
    // свод раздела). Значит строка не наша.
    return false;
  };

  return { pages, applySet, tapRow };
}

/**
 * Шторка «Тихие часы»: тумблер, границы времени и часовой пояс.
 *
 * ВРЕМЯ — общим компонентом TimePick: в приложении это РОДНОЕ колесо времени iOS, в вебе
 * два штатных списка набора (канон DateTimePick/NATIVE-SLIDE §11). Своего выбора времени
 * тут не заводим и системный `input type="time"` не ставим — он в приложении открывает
 * чужой полноэкранный лист.
 *
 * ПОЯС — общий TimezoneField, ВТОРАЯ ДВЕРЬ той же настройки, что в «Языке и регионе»:
 * один компонент, одна ручка, один ключ кэша — поправил здесь, увидел там же.
 *
 * Своё состояние: тело шторки живёт отдельным слоем и родительскую перерисовку не видит
 * (как у ChannelsModal), поэтому значения держим у себя и откатываем на отказ записи.
 */
function QuietModal({
  initial,
  onChange,
}: {
  initial: QuietPrefs;
  onChange: (patch: Partial<QuietPrefs>) => Promise<boolean>;
}) {
  const t = useTranslations('cabinet.settings');
  const tc = useTranslations('cabinet');
  const [val, setVal] = useState<QuietPrefs>(initial);
  // ТЕЛЕФОН В БРАУЗЕРЕ (ТЗ WEB-PARITY-3 К8, кадр iOS K04-notif-quiet): абзац-подсказка сверху,
  // подпись «Ночь», карточка-тумблер, строки «С / До» со значением справа и барабаном,
  // подсказка «Время по вашему часовому поясу.», карточка пояса.
  const phoneWeb = usePhoneLook();
  const [wheel, setWheel] = useState<'from' | 'to' | null>(null);

  const apply = async (patch: Partial<QuietPrefs>) => {
    const prev = val;
    setVal({ ...prev, ...patch });
    if (!(await onChange(patch))) setVal(prev);
  };

  if (phoneWeb) {
    const two = (n: number) => String(n).padStart(2, '0');
    const cur = wheel === 'to' ? val.to || QUIET_TO : val.from || QUIET_FROM;
    const [hh = '22', mm = '00'] = cur.split(':');
    return (
      // Абзац сверху — общая серая фраза списка (KListNote 13/17), страница начинается в 13
      // под кружками шапки, как родная (кадр iOS K04-notif-quiet).
      <FPane className="quiet-pane">
        <KListNote>{t('notifQuietNote')}</KListNote>
        <FBlock label={t('notifQuietNight')}>
          <KListGroup>
            <KListRow
              title={t('notifQuietOn')}
              control
              value={<KSwitch ariaLabel={t('notifQuietOn')} checked={val.enabled} onChange={(v) => void apply({ enabled: v })} />}
            />
          </KListGroup>
        </FBlock>
        {val.enabled ? (
          <FBlock label={null} hint={t('notifQuietTimeHint')}>
            <KListGroup>
              <KListRow title={t('notifQuietFrom')} value={val.from || QUIET_FROM} chevron onClick={() => setWheel('from')} />
              <KListRow title={t('notifQuietTo')} value={val.to || QUIET_TO} chevron onClick={() => setWheel('to')} />
            </KListGroup>
          </FBlock>
        ) : null}
        <TimezoneField phoneCaption={null} hint={t('notifQuietTzHint')} unknownHint={t('notifQuietTzUnknown')} />
        <KWheelDialog
          open={wheel !== null}
          title={wheel === 'to' ? t('notifQuietTo') : t('notifQuietFrom')}
          doneLabel={tc('done')}
          columns={[
            { key: 'h', cyclic: true, value: hh, items: Array.from({ length: 24 }, (_, i) => ({ value: two(i), label: two(i) })) },
            { key: 'm', cyclic: true, value: mm, items: Array.from({ length: 60 }, (_, i) => ({ value: two(i), label: two(i) })) },
          ]}
          onDone={([h, m2]) => {
            const next = `${h ?? hh}:${m2 ?? mm}`;
            void apply(wheel === 'to' ? { to: next } : { from: next });
            setWheel(null);
          }}
          onClose={() => setWheel(null)}
        />
      </FPane>
    );
  }

  return (
    <FPane>
      <FBlock label={t('notifQuietHead')} hint={t('notifQuietNote')}>
        <KSwitch
          checked={val.enabled}
          label={t('notifQuietOn')}
          hint={t('notifQuietOnHint')}
          onChange={(v) => void apply({ enabled: v })}
        />
        {/* Границы прячем у выключенных: настраивать нечего, а два поля времени под
            снятым тумблером читаются как «всё равно работает». */}
        {val.enabled ? (
          <div className="scn-duo-fields">
            <FIn label={t('notifQuietFrom')}>
              <TimePick
                value={val.from || QUIET_FROM}
                ariaLabel={t('notifQuietFrom')}
                onChange={(v) => void apply({ from: v })}
              />
            </FIn>
            <FIn label={t('notifQuietTo')}>
              <TimePick
                value={val.to || QUIET_TO}
                ariaLabel={t('notifQuietTo')}
                onChange={(v) => void apply({ to: v })}
              />
            </FIn>
          </div>
        ) : null}
      </FBlock>
      <TimezoneField hint={t('notifQuietTzHint')} unknownHint={t('notifQuietTzUnknown')} />
    </FPane>
  );
}

/** Модалка «куда присылать» (сводки, новости, «Важные»): один пузырь-выбор с галочками.
 *  Своё состояние: тело модалки живёт отдельным слоем и родительскую перерисовку не видит. */
function ChannelsModal({
  initial,
  email,
  tgLinked,
  tgBlocked,
  tgName,
  pushDenied,
  ensurePush,
  onChange,
  intro,
  hint,
  minOne = false,
  onBlocked,
  noPush = false,
}: {
  initial: ChSet;
  email: string;
  tgLinked: boolean;
  tgBlocked: boolean;
  tgName: string | null;
  pushDenied: boolean;
  ensurePush: () => Promise<boolean>;
  onChange: (next: ChSet) => Promise<boolean>;
  /** Вступление формы серым («Важные» объясняются до галочек). */
  intro?: ReactNode;
  /** Подсказка под пузырём выбора. */
  hint?: ReactNode;
  /** «Важные»: последнюю галочку снять нельзя — правку не отправляем вовсе. */
  minOne?: boolean;
  onBlocked?: () => void;
  /** Веб: варианта «пуш» нет — только Телеграм и почта; push остаётся как был. */
  noPush?: boolean;
}) {
  const t = useTranslations('cabinet.settings');
  const channelRows = useChannelRows();
  const [val, setVal] = useState<ChSet>(initial);

  const apply = async (values: string[]) => {
    const next: ChSet = {
      // Веб: галочки пуша нет — его значение не трогаем (сервер из веба push не берёт).
      push: noPush ? val.push : values.includes('push'),
      tg: values.includes('tg'),
      email: values.includes('email'),
    };
    // Последний способ доставки «Важных» снимать нельзя: объясняем причину и НЕ трогаем
    // галочку — иначе она успела бы мигнуть и вернуться (капкан №6; тот же отказ ждёт и
    // на сервере — need_one_channel). В вебе считаются только видимые Телеграм и почта.
    if (minOne && (noPush ? !next.tg && !next.email : urgentWouldEmpty(next))) {
      onBlocked?.();
      return;
    }
    // Пуш включается только после системного разрешения (в вебе ensurePush пропускает).
    if (next.push && !val.push && !(await ensurePush())) return;
    const prev = val;
    setVal(next);
    if (!(await onChange(next))) setVal(prev);
  };

  const values = [val.push && !noPush ? 'push' : '', val.tg ? 'tg' : '', val.email ? 'email' : ''].filter(Boolean);
  // Подписи и пояснения каналов — ОБЩЕЙ рукой (useChannelRows): те же строки стоят у
  // тумблеров родной страницы приложения.
  const options = channelRows({ email, tgLinked, tgBlocked, tgName, pushDenied, noPush });

  // Телефон (К7/К9, кадры iOS K04-notif-news / -urgent): без подписи «Куда присылать» и
  // без абзаца сверху — одна подсказка под карточкой.
  const phone = phoneWebNow();
  return (
    <FPane {...(phone ? { className: 'ch-pane' } : {})}>
      {intro && !phone ? <FHint>{intro}</FHint> : null}
      <FChoiceManyBlock
        label={phone ? null : t('notifWhereHead')}
        values={values}
        options={options}
        {...(hint ? { hint } : {})}
        onChange={(v) => void apply(v)}
      />
    </FPane>
  );
}

/**
 * ЛИЦО АККАУНТА в строке «Сообщений» (владелец 02.09.2026): фотография инстаграм-аккаунта
 * или бота, а нет её (или не отдалась) — значок канала на плитке строки. Тот же порядок,
 * что у аватара карточки бота (ScnCardAvatar в scenarios.tsx): фото главнее знака сети,
 * но дыры вместо лица не бывает. Второго конвейера фото в кабинете нет — адрес приходит
 * готовым из ручки настроек.
 */
function AccMark({ acc }: { acc: Acc }) {
  const [failed, setFailed] = useState(false);
  if (acc.avatar && !failed) {
    // eslint-disable-next-line @next/next/no-img-element -- своя ручка, не next/image
    return <img className="fk-nrow-ava" src={acc.avatar} alt="" width={20} height={20} decoding="async" loading="lazy" onError={() => setFailed(true)} />;
  }
  return acc.channel === 'ig' ? <InstaGlyph size={20} /> : <TgGlyph size={20} />;
}

/** Модалка «Сообщения пользователей»: СПИСОК аккаунтов со своим режимом у каждого
 *  (владелец 12.08 вечер — паттерн «Уведомления → приложение» системных настроек iPhone).
 *  Каналов доставки тут нет вовсе — канал один, пуш. Строка ведёт во вторую, НИЗКУЮ
 *  шторку выбора режима; никаких органов управления на самих строках. */
function MessagesModal({
  initial,
  accounts,
  onSet,
  onSetAll,
  onForget,
  ensurePush,
}: {
  initial: MsgPrefs;
  accounts: Acc[];
  onSet: (key: string, mode: MsgMode) => Promise<boolean>;
  onSetAll: (mode: MsgMode) => Promise<boolean>;
  /** Снять запись отключённого аккаунта (строка уходит вместе с ней). */
  onForget: (key: string) => Promise<boolean>;
  ensurePush: () => Promise<boolean>;
  /** Открыть ЭТУ шторку заново (веб-ветка возврата из низкой шторки; в приложении не
   *  зовётся — там родитель жив под слоем, канон NATIVE-SLIDE §11 п.8). */
}) {
  const t = useTranslations('cabinet.settings');
  const panel = useSlidePanel();
  // Своё состояние: тело модалки живёт отдельным слоем и родительскую перерисовку не видит.
  const [modes, setModes] = useState<Record<string, MsgMode>>(initial.modes);

  // СПИСОК = РЕАЛЬНОСТЬ (Н2): живые подключения + осиротевшие записи карты. Считаем его
  // ЗДЕСЬ, а не берём с сервера как есть: сняли запись отключённого аккаунта — строка
  // обязана уйти в тот же миг, не дожидаясь перезагрузки настроек.
  const rows = msgSettingsAccounts(accounts, modes);
  const list = modeList(modes, rows);
  const one = oneMode(list);
  const allOff = one === 'off';
  const word = (m: MsgMode) => t(modeKey(m));

  // Применяем режим: оптимистично на месте, откат при отказе сервера. false — режим НЕ
  // ставим (система не дала разрешения на пуш), шторку выбора не закрываем.
  const applyMode = async (key: string, mode: MsgMode): Promise<boolean> => {
    // Включение из полного молчания сперва спрашивает системное разрешение на пуш
    // (в вебе ensurePush пропускает).
    if (mode !== 'off' && allOff && !(await ensurePush())) return false;
    // ПОРЯДОК КАДРОВ (владелец 12.08, видео IMG: лист прыгал 40% пути одним кадром):
    // запись и тяжёлый ререндер сводок родителя — ПОСЛЕ первого отрисованного кадра
    // уезда листа (double-rAF, тот же приём, что у открытия в drawer.tsx). Иначе
    // transition стартует в кадре, где браузер рисует новый список, и первый видимый
    // кадр анимации приходит с просроченными часами — скачок.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const prev = modes;
        // Своё состояние слоя — по тем же правилам, что и запись: у «Все аккаунты» карта
        // схлопывается, у аккаунта личная запись заводится или снимается (msgModeEdit).
        setModes(key === '*' ? { '*': mode } : msgModeEdit(prev, key, mode).modes);
        void (key === '*' ? onSetAll(mode) : onSet(key, mode)).then((ok) => {
          if (!ok) setModes(prev);
        });
      }),
    );
    return true;
  };

  // Возврат из низкой шторки: закрыть ВЕРХНИЙ слой — и в приложении, и в вебе
  // (веб-drawer держит лист-2 ПОВЕРХ живой модалки с тех пор, как первый уровень
  // стал горизонтальным; прежний reopen переоткрывал родителя ПОД висящим листом
  // и терял его состояние — находка охотника за дёрганием, 12.08).
  const back = () => panel.close();

  // Снять запись отключённого аккаунта: оптимистично на месте, откат при отказе сервера.
  const forget = (key: string) => {
    const prev = modes;
    setModes(Object.fromEntries(Object.entries(prev).filter(([k]) => k !== key)));
    void onForget(key).then((ok) => {
      if (!ok) setModes(prev);
    });
  };

  const openMode = (key: string, title: string, off?: boolean) => {
    panel.open({
      title,
      // Вариантов три — лист НИЗКИЙ (канон: простые панели нижним листом). У отключённого
      // аккаунта ниже ещё и кнопка «убрать из списка» — листу нужно чуть больше высоты.
      sheet: true,
      sheetDetent: off ? 0.56 : 0.45,
      body: (
        <ModeSheet
          current={msgModeShown(modes, key)}
          all={key === '*'}
          hint={key === MSG_MODE_NEW ? t('notifMsgNewHint') : off ? t('notifMsgOffHint') : undefined}
          {...(off
            ? {
                onForget: () => {
                  forget(key);
                  back();
                },
              }
            : {})}
          onPick={async (mode) => {
            if (await applyMode(key, mode)) back();
          }}
        />
      ),
    });
  };

  // Строка аккаунта: слева ЛИЦО АККАУНТА — фотография инстаграм-аккаунта или бота
  // (владелец 02.09.2026, отменяет знак сети). Фото отдаёт наша ручка; нет его или не
  // отдалось — плитка канала со значком, ровно как у аватара карточки бота
  // (ScnCardAvatar): дыры вместо лица быть не должно. Цвет плитки — из словаря
  // (Телеграм синий, Инстаграм розовый #e23570), пометка «отключён» остаётся серой
  // припиской в сводке.
  const accIcon = (a: Acc) => <AccMark acc={a} />;

  return (
    <FPane>
      <FNotifyList
        label={t('notifWhereHead')}
        items={[
          {
            key: '*',
            label: t('notifMsgAll'),
            icon: <GridGlyph />,
            iconColor: 'var(--violet)',
            // Один режим у всех — он же и написан; разнобой — «настроены по-разному».
            summary: one === null ? t('notifMsgMixed') : word(one),
            onOpen: () => openMode('*', t('notifMsgAll')),
          },
          {
            // «По умолчанию для новых аккаунтов» — ВТОРОЙ строкой, сразу под «Все
            // аккаунты» (владелец 2026-08-21, Н2): это про аккаунт, которого ещё нет,
            // поэтому стоит выше списка живых и никого из них не меняет.
            key: MSG_MODE_NEW,
            label: t('notifMsgNew'),
            icon: <NewAccGlyph />,
            iconColor: 'var(--green)',
            summary: word(msgModeShown(modes, MSG_MODE_NEW)),
            onOpen: () => openMode(MSG_MODE_NEW, t('notifMsgNew')),
          },
          ...rows.map((a) => ({
            key: a.key,
            // ЗНАК СЕТИ ПОСЛЕ ЛОГИНА — ТОТ ЖЕ, ЧТО У НАЗВАНИЯ БОТА НА «БОТАХ» (владелец
            // 19.09.2026, отменяет «перед логином» от 10.09): `.scn-name-chan` + ChannelIcon 14.
            // Зеркало `titleImage`/`titleImageColor` родной строки.
            label: (
              <>
                {a.name}
                <span className="scn-name-chan" aria-hidden>
                  <ChannelIcon channel={a.channel === 'ig' ? 'instagram' : 'telegram'} size={14} />
                </span>
              </>
            ),
            icon: accIcon(a),
            iconColor: a.channel === 'ig' ? '#e23570' : 'var(--blue)',
            summary: a.off ? `${t('notifAccOff')} · ${word(msgModeShown(modes, a.key))}` : word(msgModeShown(modes, a.key)),
            onOpen: () => openMode(a.key, a.name, a.off),
          })),
        ]}
      />
    </FPane>
  );
}

/** Низкая шторка выбора режима одного аккаунта, значения «По умолчанию для новых
 *  аккаунтов» или всех сразу. Выбрал — применилось и вернулись. У «Все аккаунты» (all)
 *  выбор сперва проходит подтверждение штатным ConfirmInline: в приложении это родное
 *  окно iOS, на сайте — окошко по центру шторки. Своего вопроса-диалога компонент не
 *  рисует. У отключённого аккаунта внизу — кнопка «убрать из списка» (onForget). */
function ModeSheet({
  current,
  all,
  hint,
  onForget,
  onPick,
}: {
  current: MsgMode;
  all: boolean;
  /** Серая строка под пузырём выбора: чем эта строка отличается от остальных. */
  hint?: string;
  /** Отключённый аккаунт: даём убрать его запись из настроек (кнопкой, не жестом). */
  onForget?: () => void;
  onPick: (mode: MsgMode) => void;
}) {
  const t = useTranslations('cabinet.settings');
  const [val, setVal] = useState<MsgMode>(current);
  // Вопрос задаёт не своя кнопка, а строка выбора — триггер ConfirmInline спрятан, а
  // «спросить» приходит наружу через registerAsk (тот же приём, что у карточки скрипта).
  const askRef = useRef<(() => void) | null>(null);
  // Выбранный режим — в ref: замыкание onConfirm читает его в момент согласия, а не
  // состояние прошлого рендера.
  const pendingRef = useRef<MsgMode>(current);

  const take = (mode: MsgMode) => {
    setVal(mode);
    onPick(mode);
  };
  const choose = (mode: MsgMode) => {
    if (!all) {
      take(mode);
      return;
    }
    pendingRef.current = mode;
    askRef.current?.();
  };

  return (
    <FPane>
      <FChoiceBlock
        // Заголовка над пузырём нет — тот же вид, что у родного листа выбора (владелец
        // 10.09.2026): шапка шторки уже назвала строку.
        label={null}
        value={val}
        {...(hint ? { hint } : {})}
        options={[
          { value: 'all', label: t('notifMsgScopeAll'), hint: t('notifMsgScopeAllHint') },
          { value: 'manual', label: t('notifMsgScopeManual'), hint: t('notifMsgManualHint') },
          { value: 'off', label: t('notifMsgScopeNone'), hint: t('notifMsgScopeNoneHint') },
        ]}
        onChange={(v) => choose(v === 'off' ? 'off' : v === 'manual' ? 'manual' : 'all')}
      />
      {onForget ? (
        <DActions>
          <KButton size="sm" onClick={onForget}>
            {t('notifMsgForget')}
          </KButton>
        </DActions>
      ) : null}
      {all ? (
        // Триггер спрятан; сами вопрос и кнопки рисуются порталом (родное окно iOS /
        // окошко по центру шторки / нижний лист старых сборок) — прятание им не мешает.
        <span style={{ display: 'none' }}>
          <ConfirmInline
            label=""
            question={t('notifMsgAllQ')}
            danger={false}
            onConfirm={() => take(pendingRef.current)}
            registerAsk={(fn) => {
              askRef.current = fn;
            }}
          />
        </span>
      ) : null}
    </FPane>
  );
}

/**
 * ЛЕНТА «ПОЛУЧЕННЫХ» — ОДНА МЕХАНИКА на веб-шторку и на РОДНОЙ экран приложения
 * (волна 2, Опус-В2Б). Здесь всё, что не разметка: живое состояние ленты, отметка
 * «прочитано», догрузка страниц и нарезка по дням. Второй правды о ленте в кабинете
 * нет — родной экран берёт ту же самую.
 *
 * В ПРИЛОЖЕНИИ платёжных записей в ленте нет вовсе (CLAUDE.md запрет №7).
 */
function useInboxFeed() {
  const t = useTranslations('cabinet.settings');
  const locale = useLocale();
  // В приложении платёжное не показываем (запрет №7). Детект — по тому же признаку, что
  // везде в кабинете прячет цены (UA приложения), а не по методу моста: правило про
  // сторы обязано работать и в старых сборках. Тот же признак сервер читает сам, когда
  // считает непрочитанное для пилюли (lib/pay-notices.ts + ручка notify-inbox).
  const hidePay = useNativeApp();
  // Состояние ОБЩЕЕ со страницей (inboxStore): своей копии у шторки нет — иначе пилюля
  // под ней гасла бы только на закрытии. Первый экран уже загружен страницей, поэтому
  // открытие не мигает пустотой. Замыкания «прочитать» и «догрузить» читают inboxStore
  // напрямую — он всегда свежий, снимок своего рендера им не нужен.
  const inbox = useInbox();
  const [busy, setBusy] = useState(false);
  // Сеть отказала на догрузке — страж отдыхает и пробует снова через паузу: без этого
  // он звал бы ручку в цикле (полоска-то по-прежнему на экране).
  const [pause, setPause] = useState(false);
  // Страница ещё не догрузила ленту (шторку открыли сразу) — грузим сами.
  useEffect(() => {
    if (inboxStore) return;
    void refreshInbox();
  }, []);

  // Оптимистичная отметка: помечаем на месте, при отказе сервера возвращаем прежнее.
  const markRead = useCallback(async (ids: string[] | 'all') => {
    const prev = inboxStore;
    if (!prev) return;
    const touched = prev.items.filter((n) => !n.readAt && (ids === 'all' || ids.includes(n.id)));
    if (ids !== 'all' && touched.length === 0) return;
    const now = new Date().toISOString();
    const unreadLeft = ids === 'all' ? 0 : Math.max(0, prev.unread - touched.length);
    setInbox({
      ...prev,
      items: prev.items.map((n) =>
        !n.readAt && (ids === 'all' || ids.includes(n.id)) ? { ...n, readAt: now } : n,
      ),
      // «Всё» гасит и то, что ещё не загружено, — цифра нулевая.
      unread: unreadLeft,
    });
    if (!(await saveRead(ids))) {
      setInbox(prev);
      return;
    }
    // Прочитанное не должно висеть пушем в шторке iOS (владелец 2026-08-25: «при
    // открытии новости пуш не снялся»): свои записи снимаем по id, а когда непрочитанного
    // не осталось — чистим всё (старые пуши без nid по id не найти).
    clearDeliveredPush(unreadLeft === 0 ? 'all' : touched.map((n) => n.id));
  }, []);

  // INVARIANT(scriptera): открытие ленты САМО ПО СЕБЕ ничего не читает — авто-отметки
  // «просмотрел ленту = прочитал всё» здесь нет и заводить её нельзя.
  // Причина: владелец 2026-08-21 — «непрочитанных не вижу никогда, хотя я их точно не
  // открывал». Запись читается ровно двумя руками: тап по записи (openItem) и явная
  // кнопка «Прочитать всё». Наклейку на иконке при открытии ленты всё равно приводит к
  // правде сама ручка GET (тихий пуш с текущей цифрой) — гасить для этого непрочитанное
  // не требуется. Канон: docs/CABINET-UX-FIXLIST.md, У1.

  // Догрузка следующей страницы курсором ручки (?before=<время самой старой записи>).
  const loadMore = useCallback(() => {
    const cur = inboxStore;
    if (!cur || !cur.more || !cur.nextBefore || busy) return;
    setBusy(true);
    void loadInbox(cur.nextBefore).then((p) => {
      setBusy(false);
      const now = inboxStore;
      if (!p) {
        setPause(true);
        return;
      }
      if (!now) return;
      setInbox({
        // Свежая цифра — с сервера: за время листания могло прийти новое.
        items: [...now.items, ...p.items],
        unread: p.unread,
        nextBefore: p.nextBefore,
        more: p.more,
        overdue: p.overdue,
      });
    });
  }, [busy]);

  // Отдых после отказа сети — и снова пробуем (страж всё это время на месте).
  useEffect(() => {
    if (!pause) return;
    const id = setTimeout(() => setPause(false), 5000);
    return () => clearTimeout(id);
  }, [pause]);

  // Время записи и подпись дня — Intl по языку кабинета (свои форматы дат запрещены).
  const fmtTime = (iso: string) =>
    new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(new Date(iso));
  const fmtDay = (iso: string) => {
    const d = new Date(iso);
    const today = new Date();
    const at = (x: Date) => `${x.getFullYear()}-${x.getMonth()}-${x.getDate()}`;
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    if (at(d) === at(today)) return t('notifToday');
    if (at(d) === at(yesterday)) return t('notifYesterday');
    return new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      ...(d.getFullYear() === today.getFullYear() ? {} : { year: 'numeric' }),
    }).format(d);
  };

  // Группы по дням: записи приходят от новых к старым, поэтому день меняется подряд.
  const groups = useMemo(() => {
    const shown = (inbox?.items ?? []).filter((n) => !hidePay || !isPayNotice(n.key));
    const out: { day: string; items: Notice[] }[] = [];
    for (const n of shown) {
      const day = fmtDay(n.createdAt);
      const last = out[out.length - 1];
      if (last && last.day === day) last.items.push(n);
      else out.push({ day, items: [n] });
    }
    return out;
    // fmtDay зависит только от языка и текущего дня — пересобирать группы больше не на что.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inbox, hidePay, locale]);

  // Есть ли что читать — по ПОКАЗАННОМУ (в приложении платёжное скрыто, и обещать
  // «прочитать всё» из-за него нельзя).
  const hasUnread = groups.some((g) => g.items.some((n) => !n.readAt));

  return { inbox, groups, hasUnread, busy, pause, markRead, loadMore, fmtTime, fmtDay };
}

/**
 * ШТОРКА «ПОЛУЧЕННЫЕ» — веб-вид ленты (этап 4 плана, вид утверждён владельцем 12.08).
 * Механика общая (useInboxFeed выше), здесь только разметка и шторка самой записи.
 */
function InboxModal({ focusId }: { focusId?: string }) {
  const t = useTranslations('cabinet.settings');
  const panel = useSlidePanel();
  const { inbox, groups, hasUnread, busy, pause, markRead, loadMore, fmtTime, fmtDay } = useInboxFeed();
  // Страж конца ленты — пустая полоска после последней записи (см. эффект ниже).
  const tailRef = useRef<HTMLDivElement>(null);
  // «Спросить» у общего подтверждения кабинета: свой диалог тут не заводим.
  const askReadAll = useRef<(() => void) | null>(null);

  const openItem = (n: Notice) => {
    if (!n.readAt) void markRead([n.id]);
    // Шторка записи (владелец 12.08 вечер): горизонтальный слой СТОПКОЙ поверх ленты —
    // только эта запись целиком, «назад» возвращает в ленту. Никаких переходов по
    // адресу записи отсюда (прежний router.push закрывал всю шторку и выглядел как сбой).
    panel.open({
      title: n.title,
      // ТЕЛЕФОН В БРАУЗЕРЕ (владелец 09.10.2026, запись экрана): запись — страница ВНУТРИ листа ленты,
      // едет справа налево в его пределах, лист ленты остаётся под ней; «‹» снимает только запись.
      // Прежде здесь ехал боковой слой на весь экран поверх всего — ошибка.
      ...(phoneWebNow() ? { sheet: true, inSheet: true, lead: 'back' as const } : {}),
      // «Сегодня · 08:50» — ЗАГОЛОВОК НАД ПУЗЫРЁМ, ровно как подписи дней в ленте
      // (владелец 2026-08-21, Н4): раньше время лежало первой строкой внутри пузыря и
      // читалось вторым сообщением.
      body: (
        <FPane>
          <FBlock label={`${fmtDay(n.createdAt)} · ${fmtTime(n.createdAt)}`}>
            <p style={{ margin: 0, lineHeight: 1.55, overflowWrap: 'anywhere' }}>{n.body || n.title}</p>
          </FBlock>
        </FPane>
      ),
    });
  };

  // АВТОПОДГРУЗКА (владелец 21.08, в10: кнопка «показать ещё» ушла). Страж — полоска в
  // конце ленты; догружаем, как только она показалась.
  // КАПКАН КАРКАСА: следим за стражем ОТНОСИТЕЛЬНО ЭКРАНА (root по умолчанию), а не за
  // скроллом какого-то контейнера. Причина: на телефоне скроллится ДОКУМЕНТ (канон
  // docs/concepts/SAFE-AREA-SHELL-REBUILD.md), а в вебе — своя шторка со своим скроллом;
  // наблюдатель по экрану верен в обоих случаях.
  useEffect(() => {
    const el = tailRef.current;
    if (!el || busy || pause || !inbox?.more || !inbox.nextBefore) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) loadMore();
      },
      // Берём страницу заранее, до самого края: листающий человек не должен упираться.
      { rootMargin: '400px 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [busy, pause, inbox?.more, inbox?.nextBefore, loadMore]);

  // Пуш привёл в КОНКРЕТНУЮ запись (?inbox=<id> → focusId): как только лента загрузилась,
  // открываем её шторкой поверх — «нужная новость» видна сразу, а не ищется в списке.
  // Записи нет на первой странице (старьё) — остаёмся на ленте, человек долистает.
  const focusDone = useRef(false);
  useEffect(() => {
    if (!focusId || focusDone.current) return;
    const n = inbox?.items.find((x) => x.id === focusId);
    if (!n) return;
    focusDone.current = true;
    openItem(n);
    // openItem пересоздаётся каждый рендер — эффект живёт по появлению записи в ленте.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusId, inbox]);

  if (!inbox) {
    return (
      <FPane>
        <FNotifyList
          className="sk-hold"
          items={[0, 1, 2].map((i) => ({
            key: String(i),
            label: <Sk w={160} h={14} />,
            summary: <Sk w={210} h={12} />,
            onOpen: () => {},
          }))}
        />
      </FPane>
    );
  }

  // ХВОСТ ЛЕНТЫ: страж автоподгрузки (см. эффект выше) и скелетон на время догрузки.
  // Кнопки тут нет — страницы приезжают сами.
  const tail = inbox.more ? (
    <div
      ref={tailRef}
      aria-hidden
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 28 }}
    >
      {busy ? <Sk w={140} h={12} /> : null}
    </div>
  ) : null;

  if (groups.length === 0) {
    return (
      <FPane className="inbox-empty">
        {/* Показывать нечего, но лента не кончилась — в приложении страница могла целиком
            оказаться денежной (её не видно, запрет №7). Это не «пусто»: ждём следующую
            страницу, её приведёт тот же страж. */}
        {tail ?? <DEmpty>{t('notifInboxEmpty')}</DEmpty>}
      </FPane>
    );
  }

  return (
    <FPane>
      {/* Один общий пузырь НА ДЕНЬ (владелец 12.08: «для каждого дня один общий
          пузырь, с хорошими отступами»): подпись дня — имя пузыря, записи — строками
          внутри с разделителями. */}
      {groups.map((g, gi) => (
        <FNotifyList
          key={g.day}
          className="fk-feed"
          label={
            // «Прочитать всё» — в подписи ПЕРВОГО дня справа, и только когда есть
            // непрочитанное (владелец 12.08, этап 6). Подпись пузыря — <label>, а
            // кнопка внутри него становится его «полем»: тап по слову «Сегодня» иначе
            // сработал бы как нажатие кнопки — гасим это preventDefault на обёртке
            // (сам обработчик кнопки к этому моменту уже отработал).
            // Прочитать всё — только с согласия (владелец 21.08, в10): вопрос задаёт
            // общее подтверждение кабинета (ConfirmInline ниже) через registerAsk —
            // родное окно в приложении, окошко по центру шторки в вебе. Своего диалога
            // тут нет и заводить его нельзя.
            gi === 0 && hasUnread ? (
              <span
                onClick={(e) => e.preventDefault()}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}
              >
                {g.day}
                <KBareButton className="meta" style={{ flex: 'none' }} onClick={() => askReadAll.current?.()}>
                  {t('notifReadAll')}
                </KBareButton>
              </span>
            ) : (
              g.day
            )
          }
          items={g.items.map((n) => ({
            key: n.id,
            chevron: false,
            label: (
              <span style={{ display: 'flex', alignItems: 'flex-start', gap: 8, width: '100%', minWidth: 0 }}>
                {n.readAt ? null : (
                  // Непрочитанное — розовая точка (цвет-галочка словаря; строку фоном
                  // не красим).
                  <span aria-hidden className="ntf-dot" />
                )}
                <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{n.title}</span>
                <span
                  style={{
                    flex: 'none',
                    marginLeft: 'auto',
                    paddingLeft: 8,
                    fontWeight: 400,
                    fontSize: 12.5,
                    // Третичным, как time родной записи (.tertiaryLabel; паритет 09.09.2026).
                    color: 'var(--mut-2)',
                  }}
                >
                  {fmtTime(n.createdAt)}
                </span>
              </span>
            ),
            ...(n.body
              ? {
                  summary: (
                    // Длинный текст обрезается двумя строками — в ленте важен зачин,
                    // остальное человек увидит там, куда ведёт запись.
                    <span
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {n.body}
                    </span>
                  ),
                }
              : {}),
            onOpen: () => openItem(n),
          }))}
        />
      ))}
      {tail}
      {/* Триггер спрятан; вопрос и кнопки рисуются порталом (родное окно iOS / окошко по
          центру шторки / нижний лист старых сборок) — прятание им не мешает. */}
      <span style={{ display: 'none' }}>
        <ConfirmInline
          label=""
          question={t('notifReadAllQ')}
          danger={false}
          onConfirm={() => void markRead('all')}
          registerAsk={(fn) => {
            askReadAll.current = fn;
          }}
        />
      </span>
    </FPane>
  );
}

// ── РОДНЫЕ «ПОЛУЧЕННЫЕ» В ПРИЛОЖЕНИИ (волна 2, Опус-В2Б) ────────────────────────────
//
// Ленту рисует натив (InboxScreen.swift), а этот кусок — её мозг: та же механика ленты
// (useInboxFeed), та же отметка «прочитано», та же догрузка. Своей веб-разметки у него
// нет вовсе — он ничего не выводит, кроме спрятанного общего подтверждения кабинета
// («Прочитать всё» спрашивает родным окном iOS, своего диалога тут нет).
//
// INVARIANT(scriptera): в приложении центр открывается ТОЛЬКО этим экраном — веб-слой
// (panel.open) при живом родном экране не поднимаем. Причина та же, что у родного
// мастера (П-23, владелец 30.08.2026): слой — отдельный нативный экран, он въезжает
// вбок и стоит под родным пустым белым листом. Канон: docs/NATIVE-SLIDE-PLAN.md §11.

/** Открытая родная лента: id записи, которую надо показать сразу (пусто — сама лента). */
let inboxNative: { focus: string; seq: number } | null = null;
let inboxNativeSub: ((v: typeof inboxNative) => void) | null = null;
let inboxNativeSeq = 0;

/** Открыть родную ленту (её зовёт общая рука кабинета — useOpenInbox). */
function openNativeInbox(focusId?: string): void {
  inboxNativeSeq += 1;
  inboxNative = { focus: focusId ?? '', seq: inboxNativeSeq };
  // ЖУРНАЛ: просьба поднять родную ленту и есть ли кому её услышать. `host:false` —
  // хозяин (InboxNativeHost) не смонтирован, и лента не поднимется ничем.
  journalLog('inbox.open.ask', { seq: inboxNativeSeq, host: !!inboxNativeSub, focus: !!focusId });
  inboxNativeSub?.(inboxNative);
}

function closeNativeInbox(): void {
  inboxNative = null;
  inboxNativeSub?.(null);
}

/** Хозяин родной ленты: стоит один на кабинет (внутри InboxDeepLink, рядом с PushOpen). */
function InboxNativeHost() {
  const [st, setSt] = useState(inboxNative);
  useEffect(() => {
    inboxNativeSub = setSt;
    return () => {
      inboxNativeSub = null;
    };
  }, []);
  if (!st) return null;
  // Свой номер каждому открытию: лента поднимается заново, а не донашивает прошлый показ.
  return <InboxNativeScreen key={st.seq} focusId={st.focus} />;
}

function InboxNativeScreen({ focusId }: { focusId: string }) {
  const t = useTranslations('cabinet.settings');
  const { inbox, groups, hasUnread, markRead, loadMore, fmtTime, fmtDay } = useInboxFeed();
  /** Какая запись показана страницей поверх ленты (пуш привёл в саму новость). */
  const [open, setOpen] = useState(focusId);
  // «Спросить» у общего подтверждения кабинета: в приложении это родное окно iOS.
  const askReadAll = useRef<(() => void) | null>(null);

  const dark = typeof document !== 'undefined' && document.documentElement.dataset.theme === 'dark';
  const theme: 'light' | 'dark' = dark ? 'dark' : 'light';
  const data = useMemo<NativeInboxData>(
    () => ({
      theme,
      title: t('notifInbox'),
      groups: groups.map((g) => ({
        day: g.day,
        // Плитки-значка у строки НЕТ (аудит халявы 01.09): эталон — веб-лента, там
        // строка это точка непрочитанного, заголовок, время справа и зачин.
        rows: g.items.map((n) => ({
          id: n.id,
          title: n.title,
          body: n.body || n.title,
          time: fmtTime(n.createdAt),
          when: `${fmtDay(n.createdAt)} · ${fmtTime(n.createdAt)}`,
          unread: !n.readAt,
        })),
      })),
      emptyText: t('notifInboxEmpty'),
      // Слово есть, только когда есть что читать (владелец 12.08). Стоит оно в имени
      // ПЕРВОГО пузыря справа — как в вебе (аудит халявы 01.09), а не в шапке экрана.
      readAll: hasUnread ? t('notifReadAll') : '',
      loading: !inbox,
      more: !!inbox?.more,
      open,
      skin: {
        bg: readRoleHex('--bg', dark ? '#101014' : '#fbfbfd'),
        spotPink: readRoleHex('--accent-soft', '#ffe7ed'),
        spotGreen: readRoleHex('--green-soft', '#e0f5f7'),
      },
    }),
    [theme, dark, t, groups, hasUnread, inbox, open, fmtTime, fmtDay],
  );

  useNativeInbox({
    active: true,
    data,
    // Тап по записи: натив уже показал её сам (данные у него на руках), нам остаётся
    // погасить непрочитанность — той же рукой, что у веб-ленты.
    onTap: (id) => {
      const n = inbox?.items.find((x) => x.id === id);
      if (n && !n.readAt) void markRead([id]);
      setOpen(id);
    },
    onReadAll: () => askReadAll.current?.(),
    onMore: loadMore,
    onBack: () => setOpen(''),
    onGone: closeNativeInbox,
  });

  // Триггер спрятан; вопрос и кнопки рисуются порталом (в приложении — родное окно iOS),
  // поэтому спрятанный хозяин ему не мешает.
  return (
    <span style={{ display: 'none' }}>
      <ConfirmInline
        label=""
        question={t('notifReadAllQ')}
        danger={false}
        onConfirm={() => void markRead('all')}
        registerAsk={(fn) => {
          askReadAll.current = fn;
        }}
      />
    </span>
  );
}
